const G='#c9a84c';
// Category — what kind of activity happens at the facility.
// Per-facility category is derived from the orgs that host events there
// (_garaFacOrgs + org.category); public-road tracks get cat='publicroad' baked in;
// venue-type tracks (v-* orgs) get cat='venue'.
const CATS=[{id:'all',label:'All'},{id:'race',label:'Race'},{id:'trackday',label:'Track Day'},{id:'school',label:'School'},{id:'publicroad',label:'Public Road'},{id:'venue',label:'Venue'}];
// Discipline — what kind of motorsport. Moto/Auto filter by org discipline;
// Road/Oval/Kart/MX/Drag/Off-Road filter by track type (facility.tp).
// Default is inherited from the rest of the site via localStorage.getItem('gara_discipline')
// so moto-side visitors see only moto; auto-side visitors see only auto.
const DISCS=[{id:'all',label:'All'},{id:'moto',label:'Moto'},{id:'auto',label:'Auto'},{id:'road',label:'Road'},{id:'oval',label:'Oval'},{id:'kart',label:'Kart'},{id:'mx',label:'MX'},{id:'supermoto',label:'Supermoto'},{id:'drag',label:'Drag'},{id:'offroad',label:'Off-Road'},{id:'drift',label:'Drift'}];
// Org-discipline expansion: which org.discipline values map into moto/auto buckets.
// Used only when discF is moto/auto/drift/supermoto. The track-type disciplines
// (road/oval/kart/mx/drag/offroad) match on facility.tp directly — see gf().
// Drift + supermoto are org-disciplines (no dedicated track type — supermoto runs
// on kart tracks + sections of road tracks; drift runs on road courses + lots).
const DISC_ORG_MEMBERS={
  moto:      {moto:1, mx:1, both:1},
  auto:      {auto:1, kart:1, drag:1, offroad:1, both:1},
  drift:     {drift:1},
  supermoto: {supermoto:1},
};
var _TRACK_TYPE_DISCS={road:1, oval:1, kart:1, mx:1, drag:1, offroad:1, supermoto:1};
// Price brackets — match an event based on its event.price_usd (omitted on
// events whose source page didn't publish a rider/driver entry fee). 'any'
// ignores price entirely. 'listed' keeps only events that have a price shown.
const PRICES=[
  {id:'all',    label:'Any',       test:function(p){return true;}},
  {id:'listed', label:'Listed',    test:function(p){return typeof p==='number';}},
  {id:'lt300',  label:'< $300',    test:function(p){return typeof p==='number'&&p<300;}},
  {id:'300_500',label:'$300–500',  test:function(p){return typeof p==='number'&&p>=300&&p<=500;}},
  {id:'gt500',  label:'> $500',    test:function(p){return typeof p==='number'&&p>500;}},
];
function _priceMatches(price){
  var def=PRICES.find(function(x){return x.id===priceF;})||PRICES[0];
  return def.test(price);
}
function _orgInDisc(orgDisc){
  if(discF==='all')return true;
  if(_TRACK_TYPE_DISCS[discF])return true;   // track-type discipline; org filter is a no-op
  var m=DISC_ORG_MEMBERS[discF];
  return !!(m && m[orgDisc]);
}
let TRACKS=[{"n":"Bristol Motor Speedway","c":"","s":"KY","la":36.5156,"lo":-82.257,"l":"0.52 mi","tu":"-","el":"-","sg":"-","tp":"oval","o":"M63,53 L64,52 L67,51 L69,49 L70,48 L71,46 L72,45 L73,44 L73,42 L73,41 L73,39 L73,37 L72,36 L71,34 L70,33 L56,13 L54,10 L52,9 L51,8 L50,8 L48,7 L46,6 L44,6 L42,6 L40,6 L38,6 L37,6 L34,7 L33,7 L31,8 L30,10 L28,11 L27,12 L27,14 L26,15 L26,17 L26,18 L26,20 L26,21 L27,22 L28,24 L43,47 L44,48 L44,48 L45,49 L47,51 L49,52 L51,53 L53,53 L55,54 L58,54 L60,53 L63,53"},{"n":"Charlotte Motor Speedway","c":"","s":"NC","la":35.3486,"lo":-80.6837,"l":"0.63 mi","tu":"-","el":"-","sg":"-","tp":"oval","o":"M16,12 L16,15 L16,16 L16,16 L16,21 L17,29 L18,32 L18,34 L19,36 L20,39 L20,39 L21,40 L21,42 L23,44 L25,46 L27,48 L29,49 L31,50 L33,51 L35,52 L38,53 L41,53 L44,54 L47,54 L50,53 L53,53 L56,52 L59,51 L62,50 L64,48 L66,47 L68,45 L69,43 L71,41 L72,39 L73,36 L74,34 L75,32 L76,30 L77,26 L79,19 L83,6"},{"n":"Charlotte Motor Speedway Karting Track","c":"","s":"NC","la":35.3544,"lo":-80.6814,"l":"0.45 mi","tu":"-","el":"-","sg":"-","tp":"oval","o":"M31,21 L29,19 L26,16 L25,15 L24,13 L24,12 L24,10 L24,9 L25,8 L26,8 L28,7 L33,6 L35,6 L38,6 L41,6 L45,6 L50,6 L51,6 L54,7 L56,7 L58,8 L59,8 L60,9 L61,10 L61,11 L62,12 L62,13 L62,15 L62,16 L61,17 L61,18 L61,19 L61,20 L61,20 L62,21 L63,22 L65,22 L67,23 L69,23 L70,23 L72,24 L73,25 L74,25 L75,26 L75,27 L76,29 L76,36 L76,38 L75,38 L74,39 L74,40 L72,40 L71,40 L69,40 L68,40 L67,40 L66,41 L65,42 L64,43 L64,45 L62,52 L61,52 L60,53 L60,53 L59,54 L57,53 L57,53 L55,53 L53,52 L52,52 L51,52 L51,51 L51,50 L51,49 L57,29 L57,27 L56,27 L55,26 L43,18 L42,18 L41,17 L40,18 L39,18 L39,18 L38,19 L38,20 L38,21"},{"n":"Charlotte Motor Speedway Roval","c":"","s":"NC","la":35.3499,"lo":-80.6827,"l":"0.77 mi","tu":"-","el":"-","sg":"-","tp":"oval","o":"M63,28 L62,32 L61,33 L60,34 L58,34 L56,35 L54,35 L41,34 L38,34 L36,36 L36,37 L36,39 L37,42 L38,43 L40,44 L41,44 L43,44 L44,44 L50,41 L51,41 L52,41 L53,41 L55,41 L56,42 L57,44 L57,47 L56,48 L55,49 L53,50 L42,53 L41,53 L38,54 L36,53 L35,53 L34,52 L33,50 L32,49 L31,48 L31,43 L31,41 L31,40 L32,33 L32,31 L33,30 L34,29 L36,27 L38,22 L42,15 L44,10 L46,8 L48,6 L52,6 L54,6 L57,6 L62,7 L65,8 L67,9 L68,12 L68,14 L66,19 L63,28"},{"n":"Charlotte Motor Speedway Roval 2024","c":"","s":"NC","la":35.3492,"lo":-80.6849,"l":"0.43 mi","tu":"-","el":"-","sg":"-","tp":"oval","o":"M78,20 L74,11 L70,9 L64,8 L59,8 L53,11 L50,15 L49,18 L48,20 L48,23 L49,25 L51,28 L63,41 L65,44 L65,46 L65,48 L63,51 L60,53 L57,54 L55,54 L50,52 L46,50 L43,47 L39,43 L37,37 L34,29 L33,19 L33,12 L33,8 L31,6 L29,6 L25,6 L24,7 L22,9 L21,17 L22,30 L23,39 L26,47"},{"n":"Charlotte Motor Speedway Roval Backstretch Chicane","c":"","s":"NC","la":35.3521,"lo":-80.6805,"l":"0.1 mi","tu":"-","el":"-","sg":"-","tp":"oval","o":"M48,54 L47,48 L46,46 L44,45 L40,43 L37,41 L36,38 L41,26 L56,13 L60,10 L63,6"},{"n":"Charlotte Motor Speedway Roval Frontstretch Chicane","c":"","s":"NC","la":35.3534,"lo":-80.6849,"l":"0.1 mi","tu":"-","el":"-","sg":"-","tp":"oval","o":"M67,6 L64,11 L61,22 L56,51 L55,53 L53,54 L51,53 L39,52 L36,52 L34,52 L32,53"},{"n":"Charlotte Motor Speedway Roval Pit Exit","c":"","s":"NC","la":35.3505,"lo":-80.684,"l":"0.15 mi","tu":"-","el":"-","sg":"-","tp":"oval","o":"M6,36 L37,45 L44,46 L54,45 L62,44 L71,39 L76,35 L82,28 L86,23 L94,13"},{"n":"Daytona Flat Track","c":"","s":"FL","la":29.1794,"lo":-81.0749,"l":"0.23 mi","tu":"-","el":"-","sg":"-","tp":"road","o":"M71,33 L53,12 L49,8 L45,6 L41,6 L37,6 L33,7 L30,10 L27,13 L26,16 L26,20 L28,25 L48,49 L51,51 L55,53 L60,54 L66,53 L70,50 L72,45 L73,42 L73,38 L71,33"},{"n":"Homestead-Miami Speedway","c":"","s":"FL","la":25.4505,"lo":-80.4123,"l":"0.46 mi","tu":"-","el":"-","sg":"-","tp":"oval","o":"M47,6 L44,7 L41,9 L38,11 L35,13 L33,15 L31,17 L30,19 L28,22 L27,24 L27,27 L26,30 L26,33 L27,35 L27,37 L28,40 L29,42 L31,44 L33,46 L34,48 L37,49 L39,50 L41,51 L44,52 L48,53 L53,54 L58,53 L63,52 L67,50 L73,48"},{"n":"Indianapolis Motor Speedway - Turn 1","c":"","s":"IN","la":39.7891,"lo":-86.2378,"l":"0.28 mi","tu":"-","el":"-","sg":"IMS Oval - Turn 1 ","tp":"oval","o":"M20,6 L20,8 L20,10 L21,15 L21,19 L23,23 L24,27 L25,29 L28,32 L30,35 L33,38 L39,43 L45,47 L49,48 L54,50 L58,51 L62,52 L67,53 L71,54 L79,54"},{"n":"Indianapolis Motor Speedway - Turn 2","c":"","s":"IN","la":39.7891,"lo":-86.2313,"l":"0.26 mi","tu":"-","el":"-","sg":"IMS Oval - Turn 2","tp":"oval","o":"M22,54 L28,53 L33,52 L38,51 L42,50 L47,48 L51,46 L53,45 L56,43 L59,41 L61,39 L66,35 L68,32 L71,29 L73,25 L75,20 L76,18 L77,16 L77,13 L77,11 L77,6"},{"n":"Indianapolis Motor Speedway - Turn 3","c":"","s":"IN","la":39.801,"lo":-86.2316,"l":"0.26 mi","tu":"-","el":"-","sg":"IMS Oval - Turn 3","tp":"oval","o":"M80,54 L80,48 L80,46 L79,43 L79,41 L78,39 L77,37 L76,35 L75,32 L73,30 L72,28 L69,26 L67,23 L64,21 L61,19 L59,17 L57,16 L55,15 L52,13 L49,11 L45,10 L42,8 L38,8 L35,7 L31,6 L26,6 L22,6 L19,6"},{"n":"Indianapolis Motor Speedway - Turn 4","c":"","s":"IN","la":39.8009,"lo":-86.2379,"l":"0.28 mi","tu":"-","el":"-","sg":"IMS Oval - Turn 4","tp":"oval","o":"M79,6 L74,6 L71,6 L67,6 L63,7 L59,8 L56,9 L52,10 L49,11 L45,13 L42,15 L39,17 L37,18 L35,20 L32,22 L31,24 L28,27 L26,31 L24,35 L23,37 L22,40 L21,44 L21,47 L21,49 L21,52 L21,54"},{"n":"Kansas Speedway","c":"","s":"KS","la":39.1159,"lo":-94.8305,"l":"1.55 mi","tu":"-","el":"-","sg":"-","tp":"oval","o":"M30,25 L29,26 L29,27 L28,29 L28,30 L28,32 L28,33 L29,35 L29,36 L31,43 L31,44 L31,45 L32,46 L33,48 L33,49 L35,50 L36,51 L37,52 L39,52 L40,53 L42,53 L43,53 L45,54 L47,54 L49,53 L50,53 L52,53 L54,52 L55,51 L57,50 L58,49 L59,48 L60,47 L61,45 L62,43 L63,41 L66,33 L70,24 L70,22 L70,21 L71,20 L71,19 L71,17 L71,16 L71,15 L70,14 L70,13 L69,12 L68,11 L68,10 L67,9 L65,8 L64,8 L63,7 L61,6 L59,6 L58,6 L56,6 L55,6 L53,6 L52,6 L51,6 L49,6 L48,7 L46,8 L45,9 L43,10 L38,14 L36,16 L34,17 L33,18 L33,19 L32,20 L31,22 L30,23 L30,25"},{"n":"Kansas Speedway Road Course","c":"","s":"KS","la":39.1133,"lo":-94.8306,"l":"1.24 mi","tu":"-","el":"-","sg":"-","tp":"oval","o":"M25,41 L27,42 L28,44 L30,46 L31,47 L32,47 L33,47 L35,47 L36,46 L39,43 L42,41 L43,41 L44,40 L46,41 L48,41 L49,41 L51,41 L53,40 L55,39 L56,37 L58,36 L69,7 L70,6 L71,6 L72,6 L73,7 L74,8 L74,9 L73,10 L63,37 L62,39 L60,41 L59,42 L57,44 L54,45 L51,47 L50,47 L48,48 L46,49 L43,49 L42,50 L42,50 L41,51 L41,52 L42,53 L44,53 L49,54 L53,53 L57,52 L61,50 L64,48 L67,45 L68,44 L69,42 L72,39"},{"n":"Lil' Texas Motor Speedway Track","c":"","s":"TX","la":33.036,"lo":-97.2759,"l":"0.2 mi","tu":"-","el":"-","sg":"-","tp":"oval","o":"M32,9 L24,7 L16,9 L10,13 L6,18 L6,23 L7,29 L11,34 L17,37 L76,52 L82,50 L88,47 L92,42 L94,36 L93,30 L89,24 L84,21 L77,19 L32,9"},{"n":"Michigan International Speedway Road Course","c":"","s":"MI","la":42.0627,"lo":-84.2334,"l":"1.93 mi","tu":"-","el":"-","sg":"-","tp":"oval","o":"M34,21 L39,22 L42,22 L43,22 L44,23 L44,23 L45,23 L46,23 L47,24 L47,24 L48,24 L48,25 L49,25 L49,25 L49,26 L50,26 L50,27 L50,27 L50,28 L50,28 L50,29 L50,29 L49,30 L49,30 L46,32 L46,33 L45,34 L45,35 L45,35 L45,36 L45,37 L45,37 L45,38 L45,38 L45,39 L45,39 L45,40 L46,40 L46,41 L46,42 L47,42 L48,43 L48,43 L49,43 L49,44 L49,44 L49,44 L50,45 L50,45 L50,46 L50,46 L50,47 L49,47 L49,47 L49,48 L49,48 L48,48 L48,49 L47,49 L46,49 L46,49 L45,49 L45,49 L42,49 L40,49 L40,49 L40,49 L39,49 L39,49 L38,50 L38,50 L38,50 L38,50 L38,51 L38,51 L38,51 L38,52 L38,52 L38,52 L38,52 L38,53 L39,53 L39,53 L39,53 L40,53 L40,53 L40,53 L47,54 L48,53 L50,53 L51,53 L52,53 L53,53 L54,53 L55,52 L56,52 L56,52 L57,52 L58,51 L59,51 L60,50 L61,50 L61,49 L67,46 L67,46 L67,45 L68,45 L68,45 L68,45 L68,44 L68,44 L68,44 L68,43 L68,43 L67,43 L67,43 L63,39 L62,39 L62,38 L62,38 L62,37 L61,37 L61,36 L61,35 L61,34 L61,34 L61,33 L63,30 L63,29 L63,28 L63,28 L63,27 L63,27 L63,26 L63,26 L63,25 L62,24 L62,23 L61,23 L61,22 L60,21 L59,21 L58,20 L58,19 L58,18 L57,17 L57,16 L57,16 L57,15 L56,15 L56,14 L55,14 L54,13 L54,12 L53,12 L52,11 L51,11 L51,11 L39,6 L39,6 L39,6 L38,6 L37,6 L36,6 L35,7 L35,7 L35,8 L31,18 L31,19 L32,20 L32,20 L33,21 L34,21 L34,21"},{"n":"Pocono Raceway","c":"","s":"NJ","la":41.055,"lo":-75.5087,"l":"2.59 mi","tu":"-","el":"-","sg":"-","tp":"road","o":"M31,11 L15,18 L14,18 L13,19 L11,20 L11,21 L10,22 L10,23 L9,24 L9,25 L9,26 L9,27 L10,29 L10,30 L11,31 L12,33 L13,34 L15,35 L16,35 L17,35 L19,36 L23,37 L23,37 L24,38 L59,48 L60,49 L61,49 L73,52 L74,53 L76,53 L78,54 L80,54 L81,53 L83,53 L85,52 L86,52 L86,51 L87,50 L88,50 L89,48 L89,47 L90,46 L90,45 L90,44 L89,43 L89,42 L89,41 L87,40 L84,36 L83,36 L81,33 L81,33 L76,28 L75,27 L61,13 L57,9 L56,8 L55,8 L54,7 L53,7 L52,6 L50,6 L49,6 L48,6 L46,6 L45,6 L43,6 L33,10 L31,11"},{"n":"Portland International Raceway","c":"","s":"OR","la":45.5986,"lo":-122.6999,"l":"0.92 mi","tu":"-","el":"-","sg":"-","tp":"road","o":"M36,46 L16,40 L12,39 L10,39 L9,38 L8,37 L7,37 L6,35 L6,33 L6,32 L6,30 L7,29 L8,28 L10,27 L12,26 L15,25 L17,24 L18,25 L20,25 L21,25 L22,26 L27,30 L28,31 L30,32 L32,32 L33,32 L35,32 L36,31 L38,30 L38,28 L40,25 L40,21 L39,17 L39,15 L40,14 L41,14 L41,13 L43,13 L44,13 L46,14 L55,17 L57,17 L60,17 L64,17 L70,18 L71,18 L72,18 L79,19 L82,20 L85,21 L89,22 L94,25"},{"n":"Road America","c":"","s":"MI","la":43.7916,"lo":-87.9953,"l":"0.06 mi","tu":"-","el":"-","sg":"-","tp":"road","o":"M79,54 L72,53 L63,51 L55,49 L49,47 L44,44 L35,38 L29,32 L25,27 L24,23 L21,15 L20,6"},{"n":"Road America Straight","c":"","s":"MI","la":43.7984,"lo":-87.9896,"l":"0.76 mi","tu":"-","el":"-","sg":"-","tp":"road","o":"M49,6 L49,10 L49,11 L49,12 L49,19 L50,30 L50,32 L50,33 L50,48 L50,51 L50,54"},{"n":"Road Atlanta Racetrack","c":"","s":"GA","la":34.1475,"lo":-83.8143,"l":"1.26 mi","tu":"-","el":"-","sg":"-","tp":"road","o":"M55,54 L55,53 L55,52 L56,49 L57,48 L57,47 L57,47 L58,46 L58,46 L58,46 L59,45 L59,45 L60,45 L60,44 L61,44 L62,44 L63,43 L64,43 L65,43 L65,43 L65,43 L65,42 L65,42 L66,42 L66,41 L66,40 L66,40 L66,39 L67,38 L68,37 L68,36 L69,36 L70,35 L72,34 L73,33 L73,32 L74,32 L74,32 L74,31 L75,31 L75,30 L75,29 L76,29 L76,28 L76,28 L77,27 L77,26 L77,26 L77,26 L77,25 L77,25 L77,24 L77,24 L77,24 L77,23 L76,23 L76,22 L75,21 L75,21 L74,20 L73,19 L72,19 L71,19 L66,16 L51,8 L48,6 L47,6 L46,6 L45,6 L44,6 L44,6 L43,6 L42,6 L42,6 L41,6 L40,6 L39,6 L38,7 L36,8 L34,9 L33,9 L32,10 L32,10 L31,10 L31,10 L30,11 L30,11 L29,12 L28,13 L28,13 L27,15 L26,16 L26,17 L26,18 L25,18 L25,18 L25,19 L26,19 L26,19 L26,20 L26,20 L27,21 L28,21 L29,22 L29,22 L29,22 L29,22 L29,22 L29,23 L27,27 L27,28 L26,31 L25,33 L24,35 L23,38 L23,39 L23,41 L22,42 L22,43 L22,45"},{"n":"Sonoma Raceway","c":"","s":"CA","la":38.1628,"lo":-122.4582,"l":"2.55 mi","tu":"-","el":"-","sg":"-","tp":"road","o":"M23,6 L23,6 L23,6 L27,8 L31,11 L32,11 L34,12 L35,12 L36,13 L38,14 L39,15 L41,16 L42,16 L43,16 L45,16 L46,16 L48,16 L49,17 L51,18 L65,27 L65,28 L65,28 L64,29 L64,29 L64,30 L65,30 L66,31 L68,31 L69,31 L71,31 L72,31 L73,32 L74,32 L75,33 L76,34 L77,35 L78,36 L79,38 L81,44 L84,51 L84,52 L84,53 L83,53 L83,53 L82,54 L81,53 L80,53 L80,53 L78,47 L76,43 L75,42 L75,41 L67,36 L62,33 L61,33 L60,33 L58,33 L53,33 L51,33 L50,33 L49,34 L48,34 L47,35 L46,36 L46,36 L45,37 L45,38 L44,39 L43,39 L42,39 L42,39 L41,39 L40,39 L38,38 L37,37 L35,35 L33,33 L32,33 L31,32 L31,31 L30,30 L29,30 L28,30 L25,30 L24,30 L23,30 L23,30 L22,29 L22,29 L21,29 L16,22 L15,21 L15,21 L16,20 L16,20 L17,20 L23,18 L25,18 L26,18 L26,18 L27,19 L28,19 L30,19 L31,20 L32,21 L33,22 L38,28 L39,29 L40,29 L41,30 L43,30 L44,30 L45,29 L46,28 L47,28 L47,27 L47,26 L47,25 L47,24 L47,24 L46,22 L45,21 L35,16 L20,9 L20,9 L22,7 L23,6 L23,6"},{"n":"Talladega Grand Prix Raceway","c":"","s":"AL","la":33.5026,"lo":-86.0002,"l":"1.36 mi","tu":"-","el":"-","sg":"-","tp":"road","o":"M30,18 L28,21 L27,25 L30,28 L38,37 L46,53 L49,54 L51,53 L53,52 L53,48 L52,45 L49,42 L47,41 L44,34 L44,31 L45,30 L47,28 L50,28 L51,29 L52,30 L59,45 L61,47 L63,48 L66,47 L69,46 L70,44 L71,42 L72,40 L70,9 L69,8 L66,7 L65,7 L63,6 L60,6 L53,6 L53,7 L30,18"},{"n":"Thunderhill Raceway","c":"","s":"CA","la":39.5403,"lo":-122.3311,"l":"2.89 mi","tu":"-","el":"-","sg":"-","tp":"road","o":"M51,17 L51,34 L51,46 L51,47 L52,48 L52,49 L53,49 L53,50 L54,50 L55,50 L56,51 L60,52 L67,53 L69,54 L70,53 L71,53 L72,53 L73,52 L73,52 L74,51 L74,51 L75,50 L75,49 L74,47 L73,46 L72,45 L67,44 L62,43 L61,42 L60,42 L60,41 L60,40 L60,40 L60,39 L60,38 L60,37 L61,37 L62,36 L63,35 L64,34 L64,34 L64,33 L64,32 L64,32 L63,30 L62,29 L62,28 L61,27 L61,27 L61,26 L61,26 L61,26 L60,26 L59,26 L59,26 L59,26 L58,25 L57,24 L57,24 L57,22 L57,22 L58,21 L59,20 L59,19 L62,18 L64,17 L64,16 L65,15 L65,14 L65,14 L64,13 L64,12 L59,8 L57,7 L55,6 L53,6 L51,6 L45,6 L41,6 L40,6 L39,6 L38,7 L36,8 L29,14 L27,15 L25,17 L25,17 L24,18 L24,18 L24,18 L24,19 L24,19 L27,24 L27,25 L28,26 L28,29 L28,32 L28,36 L29,40 L29,41 L29,41 L30,42 L31,42 L32,42 L37,42 L38,42 L39,42 L39,42 L39,41 L39,41 L39,39 L40,38 L41,37 L41,36 L42,35 L43,34 L43,32 L43,25 L43,18 L43,17 L42,12 L43,11 L44,11 L45,10 L46,11 L48,12 L50,13 L51,14 L51,14 L51,15 L51,17"},{"n":"Virginia International Raceway","c":"","s":"NC","la":36.5683,"lo":-79.2083,"l":"0.41 mi","tu":"-","el":"-","sg":"-","tp":"road","o":"M6,43 L10,41 L14,38 L17,36 L21,35 L28,32 L37,28 L46,24 L50,23 L54,21 L57,20 L59,20 L61,19 L63,19 L65,18 L66,18 L69,18 L70,17 L72,17 L75,17 L80,16 L82,16 L83,16 L85,16 L94,16"},{"n":"Watkins Glen International","c":"","s":"NY","la":42.3381,"lo":-76.9286,"l":"0.58 mi","tu":"-","el":"-","sg":"-","tp":"road","o":"M61,54 L45,53 L44,53 L43,53 L42,52 L41,52 L40,51 L39,50 L39,49 L39,48 L39,45 L39,43 L42,6"},{"n":"WeatherTech Raceway Laguna Seca","c":"","s":"CA","la":36.5809,"lo":-121.7525,"l":"0.64 mi","tu":"-","el":"-","sg":"-","tp":"road","o":"M27,6 L28,6 L28,7 L29,19 L29,20 L29,21 L29,24 L29,25 L28,27 L27,30 L24,39 L23,42 L22,44 L21,46 L21,47 L21,47 L21,48 L21,49 L21,49 L21,50 L22,50 L22,51 L22,51 L23,52 L23,52 L24,52 L25,53 L25,53 L26,53 L27,53 L27,53 L28,53 L29,54 L29,54 L30,54 L32,53 L36,53 L48,51 L58,50 L60,50 L62,49 L66,49 L67,49 L69,48 L70,48 L70,48 L71,48 L71,47 L71,47 L74,44 L75,41 L76,40 L76,39 L77,39 L77,37 L77,37 L78,35 L78,33"}];

// Try loading full dataset
const EXTRA_TRACKS=[
 {n:"Atlanta Motorsports Park",c:"Dawsonville",s:"GA",la:34.4339,lo:-83.9819,l:"2.00 mi",tu:"16",el:"135ft",sg:"-",tp:"road",o:"M50,8 L38,10 L30,14 L24,20 L20,28 L18,35 L20,42 L25,48 L32,52 L42,54 L52,53 L60,50 L66,46 L71,40 L74,33 L75,26 L74,20 L71,15 L65,11 L58,9 L50,8"},
 {n:"NCM Motorsports Park",c:"Bowling Green",s:"KY",la:37.0055,lo:-86.3555,l:"3.15 mi",tu:"23",el:"-",sg:"-",tp:"road",o:"M20,20 L30,15 L45,12 L60,14 L72,18 L80,24 L84,32 L82,40 L75,46 L65,50 L52,52 L40,50 L30,46 L22,40 L18,32 L16,24 L20,20"},
 {n:"The Ridge Motorsports Park",c:"Shelton",s:"WA",la:47.2042,lo:-123.1589,l:"2.47 mi",tu:"16",el:"130ft",sg:"-",tp:"road",o:"M15,25 L22,18 L32,14 L45,12 L58,15 L68,20 L76,28 L80,37 L77,45 L68,50 L55,53 L42,52 L30,49 L20,43 L14,35 L12,28 L15,25"},
 {n:"NOLA Motorsports Park",c:"Avondale",s:"LA",la:29.9227,lo:-90.3381,l:"2.75 mi",tu:"16",el:"-",sg:"-",tp:"road",o:"M18,22 L28,17 L42,14 L55,15 L66,19 L74,25 L79,33 L78,41 L72,48 L62,52 L50,53 L38,51 L27,47 L19,40 L15,32 L18,22"},
 {n:"Chuckwalla Valley Raceway",c:"Desert Center",s:"CA",la:33.6081,lo:-115.4047,l:"2.68 mi",tu:"17",el:"-",sg:"-",tp:"road",o:"M20,28 L28,20 L40,15 L54,13 L66,16 L74,22 L78,30 L76,38 L68,44 L57,48 L45,50 L34,48 L24,43 L17,36 L16,31 L20,28"},
 {n:"Eagles Canyon Raceway",c:"Decatur",s:"TX",la:33.2882,lo:-97.7144,l:"2.60 mi",tu:"9",el:"65ft",sg:"-",tp:"road",o:"M22,18 L32,14 L46,12 L58,15 L68,20 L74,28 L76,36 L72,44 L63,49 L51,52 L39,51 L28,47 L20,40 L16,32 L18,24 L22,18"},
 {n:"MSR Houston",c:"Angleton",s:"TX",la:29.3525,lo:-95.4833,l:"2.38 mi",tu:"17",el:"-",sg:"-",tp:"road",o:"M18,28 L24,20 L36,15 L50,13 L62,16 L72,22 L78,30 L76,38 L68,44 L56,48 L43,49 L31,46 L21,40 L15,32 L18,28"},
 {n:"Oregon Raceway Park",c:"Grass Valley",s:"OR",la:45.3636,lo:-120.8689,l:"2.30 mi",tu:"16",el:"300ft",sg:"-",tp:"road",o:"M15,20 L22,13 L34,10 L48,11 L60,14 L70,20 L76,28 L78,37 L73,45 L62,50 L49,52 L37,50 L26,45 L17,38 L12,30 L15,20"},
 {n:"GingerMan Raceway",c:"South Haven",s:"MI",la:42.3657,lo:-86.1342,l:"2.14 mi",tu:"11",el:"-",sg:"-",tp:"road",o:"M18,25 L26,18 L38,14 L52,13 L64,16 L73,22 L78,30 L76,38 L68,44 L55,48 L42,48 L30,45 L20,38 L15,30 L18,25"},
 {n:"Autobahn Country Club",c:"Joliet",s:"IL",la:41.5683,lo:-88.1775,l:"3.56 mi",tu:"20",el:"-",sg:"-",tp:"road",o:"M20,18 L32,13 L46,11 L60,14 L72,19 L79,27 L81,36 L76,44 L65,50 L52,53 L38,52 L26,48 L17,41 L13,32 L15,24 L20,18"},
 {n:"Carolina Motorsports Park",c:"Kershaw",s:"SC",la:34.5515,lo:-80.5039,l:"2.27 mi",tu:"14",el:"-",sg:"-",tp:"road",o:"M18,22 L28,16 L42,13 L55,15 L66,19 L74,25 L78,33 L76,41 L69,47 L58,51 L45,52 L33,49 L23,43 L16,35 L15,28 L18,22"},
 {n:"Hallett Motor Racing Circuit",c:"Jennings",s:"OK",la:36.2825,lo:-96.5789,l:"1.80 mi",tu:"10",el:"70ft",sg:"-",tp:"road",o:"M22,22 L32,16 L44,13 L56,15 L66,20 L73,27 L75,35 L71,42 L62,47 L51,50 L39,49 L29,45 L21,38 L17,30 L19,26 L22,22"},
 {n:"Heartland Motorsports Park",c:"Topeka",s:"KS",la:38.9886,lo:-95.8583,l:"2.50 mi",tu:"14",el:"-",sg:"-",tp:"road",o:"M17,24 L26,17 L39,13 L53,13 L65,16 L74,22 L79,30 L78,38 L71,45 L59,49 L45,50 L32,47 L22,41 L15,33 L13,27 L17,24"},
 {n:"Inde Motorsports Ranch",c:"Willcox",s:"AZ",la:32.2100,lo:-109.8667,l:"2.75 mi",tu:"16",el:"80ft",sg:"-",tp:"road",o:"M18,20 L28,14 L42,12 L56,14 L68,19 L76,26 L80,35 L76,43 L66,49 L53,52 L39,51 L27,47 L18,40 L13,31 L15,25 L18,20"}
];

// ── FAMOUS PUBLIC MOTORCYCLE ROADS ──
// Legendary open-road rides that any rider wants to hit. tp:'publicroad' keeps
// them separate from real circuits in filters. Each entry has a coarse SVG
// silhouette that fetchOSM() will upgrade to the real polyline on selection.
const PUBLIC_ROADS=[
  {n:"Tail of the Dragon (US-129)",c:"Deals Gap",s:"NC",la:35.4654,lo:-83.9215,l:"11.0 mi",tu:"318",el:"1500-1800ft",sg:"318 curves in 11 mi",tp:"publicroad",cat:"publicroad",o:"M10,50 L14,46 L19,48 L23,44 L27,46 L31,40 L35,44 L39,38 L44,42 L48,34 L53,38 L57,30 L62,34 L67,26 L71,30 L76,22 L81,26 L86,18 L90,22"},
  {n:"Cherohala Skyway (NC-143 / TN-165)",c:"Robbinsville",s:"NC",la:35.3544,lo:-83.9400,l:"43.0 mi",tu:"-",el:"900-5400ft",sg:"High-elevation cruiser",tp:"publicroad",cat:"publicroad",o:"M8,52 L14,44 L20,48 L26,38 L32,42 L38,32 L44,36 L50,26 L56,30 L62,20 L68,24 L74,14 L80,18 L86,10 L92,12"},
  {n:"Blue Ridge Parkway",c:"Asheville",s:"NC",la:35.5951,lo:-82.5515,l:"469.0 mi",tu:"-",el:"650-6053ft",sg:"Appalachian spine",tp:"publicroad",cat:"publicroad",o:"M8,42 L14,38 L20,44 L26,36 L32,42 L38,30 L44,36 L50,26 L56,32 L62,22 L68,28 L74,18 L80,24 L86,14 L92,20"},
  {n:"Skyline Drive (Shenandoah)",c:"Front Royal",s:"VA",la:38.6529,lo:-78.2628,l:"105.0 mi",tu:"-",el:"600-3680ft",sg:"75 overlooks",tp:"publicroad",cat:"publicroad",o:"M8,50 L14,44 L20,46 L26,38 L32,40 L38,32 L44,34 L50,26 L56,28 L62,20 L68,22 L74,14 L80,16 L86,8 L92,10"},
  {n:"Beartooth Highway (US-212)",c:"Red Lodge",s:"MT",la:45.0106,lo:-109.4270,l:"68.0 mi",tu:"-",el:"5200-10947ft",sg:"\"Most beautiful drive in America\"",tp:"publicroad",cat:"publicroad",o:"M8,52 L14,48 L18,42 L24,44 L28,36 L34,38 L40,30 L46,32 L52,24 L58,28 L64,20 L70,22 L76,14 L82,18 L88,10 L92,12"},
  {n:"Pacific Coast Highway (CA-1)",c:"Big Sur",s:"CA",la:36.2704,lo:-121.8081,l:"123.0 mi",tu:"-",el:"0-1000ft",sg:"Cliffside Pacific ribbon",tp:"publicroad",cat:"publicroad",o:"M6,30 L12,36 L18,30 L24,40 L30,32 L36,42 L42,34 L48,44 L54,36 L60,46 L66,38 L72,48 L78,40 L84,48 L90,42"},
  {n:"Angeles Crest Highway (CA-2)",c:"La Canada",s:"CA",la:34.3728,lo:-117.8475,l:"66.0 mi",tu:"-",el:"1700-7900ft",sg:"San Gabriel Mountains",tp:"publicroad",cat:"publicroad",o:"M8,48 L14,40 L20,44 L26,34 L32,38 L38,28 L44,32 L50,22 L56,26 L62,18 L68,22 L74,12 L80,16 L86,8 L92,12"},
  {n:"Going-to-the-Sun Road",c:"Glacier NP",s:"MT",la:48.6952,lo:-113.7169,l:"50.0 mi",tu:"-",el:"3200-6646ft",sg:"Crosses the Continental Divide",tp:"publicroad",cat:"publicroad",o:"M8,50 L16,42 L22,46 L28,36 L34,40 L40,30 L46,34 L52,24 L58,28 L66,18 L72,22 L78,14 L84,18 L92,10"},
  {n:"Three Sisters (TX-335/336/337)",c:"Leakey",s:"TX",la:29.7274,lo:-99.7584,l:"100.0 mi",tu:"-",el:"1300-2000ft",sg:"Hill Country sweepers",tp:"publicroad",cat:"publicroad",o:"M8,34 L14,40 L20,30 L26,38 L32,28 L38,40 L44,32 L50,42 L56,30 L62,40 L68,28 L74,36 L80,26 L86,34 L92,28"},
  {n:"Million Dollar Highway (US-550)",c:"Silverton",s:"CO",la:37.9395,lo:-107.6789,l:"25.0 mi",tu:"-",el:"6600-11018ft",sg:"Ouray to Silverton",tp:"publicroad",cat:"publicroad",o:"M8,50 L14,44 L20,48 L26,38 L32,42 L38,30 L44,36 L50,24 L56,30 L62,18 L68,24 L74,12 L80,18 L86,8 L92,12"},
  {n:"Natchez Trace Parkway",c:"Nashville",s:"TN",la:35.1500,lo:-86.7900,l:"444.0 mi",tu:"-",el:"100-1100ft",sg:"No trucks, no billboards",tp:"publicroad",cat:"publicroad",o:"M8,40 L15,36 L22,42 L29,36 L36,40 L43,34 L50,38 L57,32 L64,36 L71,30 L78,34 L85,28 L92,32"},
  {n:"Hana Highway (HI-360)",c:"Hana",s:"HI",la:20.8000,lo:-156.1500,l:"64.0 mi",tu:"600+",el:"0-1000ft",sg:"600 curves, 59 bridges",tp:"publicroad",cat:"publicroad",o:"M8,34 L12,42 L17,30 L22,44 L27,28 L32,42 L37,26 L42,42 L47,26 L52,42 L57,28 L62,42 L67,30 L72,42 L77,32 L82,40 L88,36"}
];
(function(){
  function buildFacilities(){
    var f=applyAliases(groupTracks(TRACKS));
    // Public roads — prefer the OSM-pulled data file (window.GARA_ROADS)
    // over the coarse inline PUBLIC_ROADS stub. Each road becomes a standalone
    // facility with no event matching; cat:'publicroad' drives the filter.
    var roads=(window.GARA_ROADS&&window.GARA_ROADS.length)?window.GARA_ROADS:PUBLIC_ROADS;
    roads.forEach(function(r){
      f.push({
        n:r.n, la:r.la, lo:r.lo, s:r.s, c:r.c, tp:r.tp||'publicroad',
        l:r.l, tu:r.tu||'-', el:r.el||'-', sg:r.sg||'',
        o:r.o,
        _geom:r.geom||null, // raw lon/lat polyline for map rendering
        configs:[Object.assign({},r,{_label:'Main',_geom:r.geom||null})],
        _activeConfig:0,
        cat:'publicroad',
        _publicRoad:true
      });
    });
    return f;
  }
  // Load tracks + roads in parallel; initialize once tracks are ready
  // (roads are optional — the page still works if gara_roads_data.js is absent).
  var tracksLoaded=false, roadsLoaded=false, initialized=false;
  function tryInit(){
    if(initialized||!tracksLoaded)return;
    initialized=true;
    FACILITIES=buildFacilities();
    init();
  }
  var sT=document.createElement('script');
  sT.src=window.GARA_DATA_URL||'gara_tracks_data.js';
  sT.onload=function(){
    if(window.GARA_TRACKS)TRACKS=window.GARA_TRACKS.concat(EXTRA_TRACKS);
    else TRACKS=TRACKS.concat(EXTRA_TRACKS);
    tracksLoaded=true;
    // Give roads a tiny moment to land, then init either way
    setTimeout(tryInit, roadsLoaded?0:400);
  };
  sT.onerror=function(){
    console.log('Using inline tracks');
    TRACKS=TRACKS.concat(EXTRA_TRACKS);
    tracksLoaded=true;
    tryInit();
  };
  document.head.appendChild(sT);

  var roadsUrl=window.GARA_ROADS_URL||(function(){
    // Derive same-origin path from tracks data URL (both served from /assets/)
    var u=window.GARA_DATA_URL||'gara_tracks_data.js';
    return u.replace(/gara_tracks_data\.js.*/,'gara_roads_data.js');
  })();
  var sR=document.createElement('script');
  sR.src=roadsUrl;
  sR.onload=function(){roadsLoaded=true;tryInit();};
  sR.onerror=function(){
    console.log('No gara_roads_data.js — falling back to inline PUBLIC_ROADS');
    roadsLoaded=true;
    tryInit();
  };
  document.head.appendChild(sR);

  setTimeout(function(){
    if(!window._garaInit){
      if(!tracksLoaded){TRACKS=TRACKS.concat(EXTRA_TRACKS);tracksLoaded=true;}
      tryInit();
    }
  },2500);
})();

let sel=null,catF='all',stateF='All',orgF='All',discF='all',priceF='all',mkrs=[],map,mapSat=null,satReady=false,simClean=null;
// Pending track selection from ?track= deeplink — resolved after data loads.
let _pendingTrackParam=null;
// Filters do NOT persist across visits -- each fresh load of the track
// finder starts from the default 'all' state. localStorage reads removed
// per user request. URL params (?d=, ?s=, ...) still seed the initial
// state so shared links still work.
try{
  var _p=new URLSearchParams(window.location.search);
  if(_p.has('d') && ['all','moto','auto','road','oval','kart','mx','supermoto','drag','offroad','drift'].indexOf(_p.get('d'))>=0) discF=_p.get('d');
  if(_p.has('s')) stateF=_p.get('s');
  if(_p.has('c')) catF=_p.get('c');
  if(_p.has('p')) priceF=_p.get('p');
  if(_p.has('o')) orgF=_p.get('o');
  if(_p.has('track')) _pendingTrackParam=_p.get('track');
}catch(e){}

// Mirror current filter state back to the URL so links remain shareable.
// Debounced via rAF since filter chains often toggle several flags in a row.
let _urlSyncQueued=false;
function syncFiltersToUrl(){
  if(_urlSyncQueued)return;
  _urlSyncQueued=true;
  requestAnimationFrame(function(){
    _urlSyncQueued=false;
    try{
      var u=new URL(window.location.href);
      function setOrDel(k,v,def){
        if(v && v!==def) u.searchParams.set(k,v); else u.searchParams.delete(k);
      }
      setOrDel('d',discF,'all');
      setOrDel('s',stateF,'All');
      setOrDel('c',catF,'all');
      setOrDel('p',priceF,'all');
      setOrDel('o',orgF,'All');
      // ?track= is handled by selTk so we only set it here if a card is active.
      var active=document.querySelector('.tc.ac');
      if(active && active.dataset.n) u.searchParams.set('track', active.dataset.n);
      else u.searchParams.delete('track');
      window.history.replaceState({}, '', u.toString());
    }catch(e){}
  });
}
let cardSims=[];
let FACILITIES=[];

// ── Perf flag + card pool ────────────────────────────────────────────
// Master kill-switch: set window.GARA_PERF=false in the URL hash / console
// and reload to disable every perf change in this build at once (the pre-
// built card pool, the moveend-only satellite sync, the bounds-change
// short-circuit). Default is on. Keeps a one-knob rollback in case any
// of these regresses without having to revert the deploy.
var PERF = (typeof window !== 'undefined' && window.GARA_PERF === false) ? false : true;
// Pre-built .tc DOM nodes keyed by facility.n. Filled once at init by
// _preBuildAllCards. buildCar() in PERF mode just looks them up and
// appendChild's the right subset -- no innerHTML, no createElement,
// no per-card listeners on every pan/zoom/filter change.
var _cardPool = {};
var _cardsPooled = false;
// Per-card sim cleanup map, used by the IntersectionObserver so cards
// scrolling OUT of view stop their requestAnimationFrame loops instead
// of leaking. WeakMap allows the cleanups to GC alongside the cards.
var _cardSimCleanup = (typeof WeakMap !== 'undefined') ? new WeakMap() : null;
// One persistent IntersectionObserver, created once after the pool is
// built. The pre-pie code re-created the observer on every buildCar
// without disconnecting the old one -- that leaked observers + callbacks
// across pans.
var _carObserver = null;

// === FACILITY GROUPING ===
// The raw data fragments single tracks into separate entries (each turn at COTA,
// each section at IMS, etc.) and also lists legitimate alt configs (Charlotte
// Roval / Roval 2024 / karting) as if they were unrelated facilities. This pass
// folds fragments away and groups configs under one parent facility.
//
// "Fragment" = section of a parent track that shouldn't stand alone:
//   - Turn N, Chicane, Pit Lane/Exit/Entry, Warmup Lane, Escape Road
//   - Single corner/feature names when they cluster around a longer track
//     (Big Bend, The Corkscrew, Esses, etc.)
// "Config" = a legit alternate layout of the same facility:
//   - CMS Roval, CMS Roval 2024, CMS Karting, CMS Quad Oval
//   - Thermal Club North/South Palm, Thermal Karting

const FRAGMENT_RX=[
  /\bTurn\s+\d+/i,                              // "Turn 1", "IMS - Turn 3"
  /\bChicane\b/i,
  /\bPit\s+(Lane|Exit|Entry|Road|Stop|Out)\b/i,
  /\bWarmup\s+Lane\b/i,
  /\bEscape\s+Road\b/i,
  /\bAlternate\s+Corner/i,
  /\bShort\s+Course\s+\d/i,
  /^(The\s+)?(Corkscrew|Esses|Hairpin|Hook|Heel|Toe|Chute|Bend|Curve|Straight|Ninety|Lefthander|Righthander)\b/i
];
function isFragment(name){return FRAGMENT_RX.some(function(r){return r.test(name);});}

function distKm(la1,lo1,la2,lo2){
  var R=6371,p1=la1*Math.PI/180,p2=la2*Math.PI/180;
  var dp=(la2-la1)*Math.PI/180,dl=(lo2-lo1)*Math.PI/180;
  var a=Math.sin(dp/2)*Math.sin(dp/2)+Math.cos(p1)*Math.cos(p2)*Math.sin(dl/2)*Math.sin(dl/2);
  return R*2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));
}

// Pick the best facility name from a set of config names.
// Scoring, in order of preference:
//   1. Longest multi-word prefix shared by 2+ configs (beats everything).
//   2. Config name containing a "facility keyword" (Raceway, Speedway, Park,
//      International, Motorsport, etc.) — longest wins. This rescues cases
//      like Laguna Seca, VIR, Watkins Glen where one sub-track entry IS the
//      facility but the others are turn names with no shared prefix.
//   3. Shortest config name as final fallback.
var FACILITY_KEYWORDS=/\b(raceway|speedway|dragway|racetrack|motorsports?\s*park|motorsport|motorpark|international|circuit|grand\s*prix|proving\s*ground|kart(ing)?\s*(track|circuit|park)|motor\s*speedway)\b/i;
function bestFacilityName(configs){
  if(configs.length===1)return configs[0].n;

  // STEP 1: shared prefix scoring
  var counts={};
  configs.forEach(function(c){
    var words=c.n.split(/\s+/);
    for(var k=1;k<=words.length;k++){
      var p=words.slice(0,k).join(' ');
      counts[p]=(counts[p]||0)+1;
    }
  });
  var best='',bestScore=0;
  Object.keys(counts).forEach(function(p){
    var shared=counts[p];
    if(shared<2)return;
    if(p.length<4)return;
    if(p.split(/\s+/).length<2)return;
    var score=shared*100+p.length;
    if(score>bestScore){bestScore=score;best=p;}
  });
  if(best)return best.replace(/[-,:\s]+$/,'').trim();

  // STEP 2: pick longest config that contains a facility keyword
  var keyworded=configs.filter(function(c){return FACILITY_KEYWORDS.test(c.n);});
  if(keyworded.length){
    keyworded.sort(function(a,b){return b.n.length-a.n.length;});
    return keyworded[0].n;
  }

  // STEP 3: shortest name (usually the "main" track at a kart park)
  var sorted=configs.slice().sort(function(a,b){return a.n.length-b.n.length;});
  return sorted[0].n;
}

function groupTracks(tracks){
  // O(n²) but n<1000 and runs once — fine.
  // 2km radius: catches opposite corners of 2.5-mile ovals like IMS without
  // over-merging adjacent but genuinely separate facilities.
  var used=new Set(),clusters=[],RADIUS_KM=2.0;
  for(var i=0;i<tracks.length;i++){
    if(used.has(i))continue;
    var cluster=[i];used.add(i);
    for(var j=i+1;j<tracks.length;j++){
      if(used.has(j))continue;
      if(Math.abs(tracks[i].la-tracks[j].la)>0.03)continue;  // bbox prefilter (~3km)
      if(Math.abs(tracks[i].lo-tracks[j].lo)>0.03)continue;
      if(distKm(tracks[i].la,tracks[i].lo,tracks[j].la,tracks[j].lo)<RADIUS_KM){
        cluster.push(j);used.add(j);
      }
    }
    clusters.push(cluster);
  }

  return clusters.map(function(idxs){
    var items=idxs.map(function(i){return tracks[i];});
    var fragments=items.filter(function(t){return isFragment(t.n);});
    var configs=items.filter(function(t){return !isFragment(t.n);});

    // All-fragment cluster: promote longest to a real config so the facility
    // still shows up (happens when the "main" track isn't in the source data).
    if(!configs.length&&fragments.length){
      fragments.sort(function(a,b){return parseFloat(b.l)-parseFloat(a.l);});
      configs.push(fragments.shift());
    }

    var facility=bestFacilityName(configs);

    // Centroid of configs (ignore fragments — they'd pull it toward one corner)
    var la=configs.reduce(function(s,t){return s+t.la;},0)/configs.length;
    var lo=configs.reduce(function(s,t){return s+t.lo;},0)/configs.length;

    // "Primary" config = longest, gets shown by default
    var primary=configs.slice().sort(function(a,b){return parseFloat(b.l)-parseFloat(a.l);})[0];

    // Strip facility prefix from config labels so the switcher chips read
    // "Roval", "Karting" etc. instead of repeating the facility name.
    var configLabels=configs.map(function(c){
      var lbl=c.n;
      if(facility&&c.n!==facility&&c.n.indexOf(facility)===0){
        lbl=c.n.slice(facility.length).replace(/^[\s\-:,]+/,'').trim()||'Main';
      }else if(c.n===facility){
        lbl='Main';
      }
      return Object.assign({},c,{_label:lbl});
    });

    // Sort configs: facility-match ("Main") first, then longest to shortest
    configLabels.sort(function(a,b){
      if(a._label==='Main')return -1;
      if(b._label==='Main')return 1;
      return parseFloat(b.l)-parseFloat(a.l);
    });

    return {
      n:facility,
      la:la,lo:lo,
      s:primary.s,c:primary.c,tp:primary.tp,
      l:primary.l,tu:primary.tu,el:primary.el,sg:primary.sg,o:primary.o,
      configs:configLabels,
      _activeConfig:0
    };
  });
}

// Manual overrides for facilities where the dataset has no entry matching
// the real name — typically because every config is a turn name (VIR's "Snake",
// Laguna Seca's "Rainey Curve") or the place is known by a nickname that isn't
// in the data. Lookup is by centroid proximity (within ~2km).
// Add to this list when you spot other clusters with obviously wrong names.
var FACILITY_ALIASES=[
  {la:39.795,lo:-86.235,name:'Indianapolis Motor Speedway'},
  {la:29.182,lo:-81.072,name:'Daytona International Speedway'},
  {la:34.436,lo:-84.177,name:'Atlanta Motorsports Park'},
  {la:34.146,lo:-83.815,name:'Michelin Raceway Road Atlanta'},
  {la:40.688,lo:-82.635,name:'Mid-Ohio Sports Car Course'},
  {la:36.221,lo:-96.594,name:'Hallett Motor Racing Circuit'},
  {la:27.453,lo:-81.350,name:'Sebring International Raceway'},
  {la:44.046,lo:-78.673,name:'Canadian Tire Motorsport Park'},
  {la:39.736,lo:-103.900,name:'High Plains Raceway'},
  {la:42.709,lo:-83.391,name:'Waterford Hills Road Racing'},
  {la:36.276,lo:-115.014,name:'Las Vegas Motor Speedway'},
  {la:35.490,lo:-119.546,name:'Buttonwillow Raceway Park'},
  {la:41.926,lo:-73.386,name:'Lime Rock Park'},
  {la:33.716,lo:-117.097,name:'Adams Motorsports Park'},
  {la:28.463,lo:-81.458,name:'Orlando Kart Center'},
  {la:33.267,lo:-111.968,name:'Radford Racing School'},
  {la:42.591,lo:-83.686,name:'GM Milford Proving Ground'},
  {la:42.264,lo:-84.048,name:'Chrysler Chelsea Proving Grounds'},
  {la:25.857,lo:-100.217,name:'Kartódromo Monterrey'},
  {la:28.053,lo:-80.624,name:'Andretti Thrill Park'},
  {la:38.339,lo:-75.117,name:'Jolly Roger Speedworld'},
  {la:38.360,lo:-75.077,name:'Baja Amusements'},
  {la:31.277,lo:-103.244,name:'Ford Arizona Proving Ground'},
  {la:34.876,lo:-118.263,name:'Willow Springs International Raceway'},
  {la:41.983,lo:-71.825,name:'Thompson Speedway Motorsports Park'},
  {la:36.816,lo:-75.995,name:'Motor World Virginia Beach'},
  {la:33.719,lo:-78.891,name:'NASCAR SpeedPark Myrtle Beach'}
];

function applyAliases(facilities){
  facilities.forEach(function(f){
    for(var i=0;i<FACILITY_ALIASES.length;i++){
      var a=FACILITY_ALIASES[i];
      if(distKm(f.la,f.lo,a.la,a.lo)<2.0){
        f.n=a.name;
        // Re-label configs against the new facility name
        f.configs.forEach(function(c){
          if(c.n===a.name){c._label='Main';return;}
          if(c.n.indexOf(a.name)===0){
            c._label=c.n.slice(a.name.length).replace(/^[\s\-:,]+/,'').trim()||'Main';
          }else{
            c._label=c.n;  // keep original when it doesn't share the alias prefix
          }
        });
        break;
      }
    }
  });
  // Merge facilities that ended up with the same name after aliasing
  // (e.g., "Indianapolis Motor Speedway" for the oval cluster + the standalone
  // "Dirt Track at IMS" entry that sits just outside the clustering radius).
  var byName={};
  facilities.forEach(function(f){
    var existing=byName[f.n];
    if(existing){
      // Fold this cluster's configs into the existing one
      f.configs.forEach(function(c){existing.configs.push(c);});
      // Recompute centroid weighted by config count
      var total=existing.configs.length;
      existing.la=(existing.la*(total-f.configs.length)+f.la*f.configs.length)/total;
      existing.lo=(existing.lo*(total-f.configs.length)+f.lo*f.configs.length)/total;
    }else{
      byName[f.n]=f;
    }
  });
  return Object.values(byName);
}

// Pull the set of categories a facility supports: 'race' / 'trackday' / 'school' / 'publicroad'.
// Derived from the orgs that host events there (each org has .category on GARA_EVENTS.orgs)
// plus a baked-in cat for public roads.
function _facilityCats(f){
  if(f.cat==='publicroad')return new Set(['publicroad']);
  if(f.cat==='venue')return new Set(['venue']);
  var cats=new Set();
  var orgsIdx=window._garaFacOrgs && window._garaFacOrgs[f.n];
  if(!orgsIdx)return cats;
  var orgMeta=(window.GARA_EVENTS && window.GARA_EVENTS.orgs)||[];
  var byId={};orgMeta.forEach(function(o){byId[o.id]=o;});
  orgsIdx.forEach(function(oid){
    var o=byId[oid];
    if(!o)return;
    // v-* venue orgs mark the facility as a venue category too
    if(o.discipline==='venue')cats.add('venue');
    var c=o.category||o.type||'trackday';
    if(c==='both'){cats.add('race');cats.add('trackday');}
    else cats.add(c);
  });
  return cats;
}

// Does the facility's track-type match the current discF (only meaningful for
// track-type disciplines: road/oval/kart/mx/drag/offroad).
function _facilityHasType(f){
  if(f.cat==='publicroad')return false;   // public roads don't match track-type filters
  if(!f.configs)return false;
  return f.configs.some(function(c){return c.tp===discF;});
}

function gf(){
  return FACILITIES.filter(function(f){
    if(catF!=='all'){
      if(catF==='publicroad')return f.cat==='publicroad'
        && (stateF==='All'||f.s===stateF);
      var cats=_facilityCats(f);
      if(!cats.has(catF))return false;
    }
    if(stateF!=='All'&&f.s!==stateF)return false;
    if(orgF!=='All'){
      var set=window._garaFacOrgs && window._garaFacOrgs[f.n];
      if(!set || !set.has(orgF))return false;
    }
    // Discipline filter — require ≥1 UPCOMING EVENT at this facility whose
    // resolved discipline matches the active filter. This is the carousel-
    // + map-marker level filter: a facility with WERA on its roster but
    // zero upcoming WERA events should NOT appear in moto mode.
    if(discF!=='all'){
      if(f.cat==='publicroad')return false;
      // Cheap pre-check: skip facilities where neither a config nor any
      // hosted org could ever match. The expensive event scan is gated.
      if(_TRACK_TYPE_DISCS[discF]){
        if(!_facilityHasType(f))return false;
      } else {
        if(!_facilityHasDisc(f))return false;
      }
      // Expensive event-level check: must have a real upcoming event with
      // resolved discipline matching the bucket.
      if(!_facilityHasUpcomingForDisc(f))return false;
    }
    // Price filter — if set to anything but Any, facility must have at least
    // one upcoming event whose price_usd matches the bracket.
    if(priceF!=='all'){
      if(f.cat==='publicroad')return false;
      if(_eventsForFacility(f).length===0)return false;
    }
    // DEFAULT: hide tracks that have zero upcoming events. Publicroad
    // facilities (back-road touring routes) are exempt because they have
    // no scheduled events by nature -- they're always-available routes.
    // showEmptyTracks=true (set by a toggle) bypasses this gate.
    if(!window.GARA_SHOW_EMPTY && f.cat !== 'publicroad'){
      if(_eventsForFacility(f).length === 0) return false;
    }
    return true;
  });
}

// Whether the facility has at least one org with a discipline matching discF.
function _facilityHasDisc(f){
  if(discF==='all')return true;
  var ids=window._garaFacOrgs && window._garaFacOrgs[f.n];
  if(!ids || !ids.size)return false;
  var orgs=(window.GARA_EVENTS && window.GARA_EVENTS.orgs)||[];
  for(var i=0;i<orgs.length;i++){
    if(!ids.has(orgs[i].id))continue;
    if(_orgInDisc(orgs[i].discipline))return true;
  }
  return false;
}

// Stronger filter for the carousel + map markers: does this facility have AT
// LEAST ONE upcoming event whose effective discipline matches discF? Mirrors
// the per-event resolution logic used by renderEvents (sniff + venue retag +
// org specialty + facility specialty + org fallback). Lazy globals are built
// once per data load; per-facility check is O(events_at_facility).
var _EVENT_DISC_BUCKETS_GLOBAL = {
  moto:{moto:1, mx:1, offroad:1, both:1},
  auto:{auto:1, kart:1, drag:1, offroad:1, both:1},
  drift:{drift:1},
  supermoto:{supermoto:1},
};
var _SPECIALTY_DISCS_GLOBAL = {mx:1, kart:1, drag:1, offroad:1, drift:1, supermoto:1};
var _SPECIALTY_FAC_GLOBAL   = {mx:1, kart:1, drag:1, offroad:1, supermoto:1};
var _ORG_DISC_GLOBAL = null;       // built lazily on first call
var _NAME_DISC_MAP_GLOBAL = null;  // built lazily on first call
function _ensureGlobalOrgMaps(){
  if(_ORG_DISC_GLOBAL && _NAME_DISC_MAP_GLOBAL) return;
  var orgs = (window.GARA_EVENTS && window.GARA_EVENTS.orgs) || [];
  var od = {};
  orgs.forEach(function(o){ od[o.id] = (o.discipline||'').toLowerCase(); });
  _ORG_DISC_GLOBAL = od;
  var nm = [];
  orgs.forEach(function(o){
    if(o.id && o.id.charAt(0)==='v') return;
    var d = (o.discipline||'').toLowerCase();
    if(!d || d==='venue') return;
    var added = {};
    function push(name){
      if(!name) return;
      var key = name.toLowerCase().trim();
      if(!key || added[key] || key.length < 6) return;
      added[key] = 1;
      nm.push({n:key, d:d});
    }
    push(o.name);
    push(o.full_name);
    push(o.short_name);
    var src = (o.full_name || o.name || '').trim();
    var stripped = src.replace(/\bracing\b|\bmotorcycle\b|\bclub\b|\btrack\s*days?\b|\bsports?\b/gi,'').trim();
    if(stripped && stripped !== src) push(stripped);
  });
  nm.sort(function(a,b){ return b.n.length - a.n.length; });
  _NAME_DISC_MAP_GLOBAL = nm;
}
function _venueRetagGlobal(ev){
  _ensureGlobalOrgMaps();
  var t = ((ev.title||'') + ' ' + (ev.org_name||'')).toLowerCase();
  var map = _NAME_DISC_MAP_GLOBAL;
  for(var i=0; i<map.length; i++){
    var entry = map[i];
    var idx = t.indexOf(entry.n);
    if(idx < 0) continue;
    var pre = idx === 0 ? ' ' : t.charAt(idx-1);
    var post = idx + entry.n.length >= t.length ? ' ' : t.charAt(idx + entry.n.length);
    if(/[a-z0-9]/.test(pre)) continue;
    if(/[a-z0-9]/.test(post)) continue;
    return entry.d;
  }
  return null;
}
function _sniffEventDiscGlobal(ev){
  var t = ((ev.title||'') + ' ' + (ev.name||'') + ' ' + (ev.description||'')).toLowerCase();
  if(/\b(mx|motocross|supercross|arenacross|sx|flat\s*track|observed\s*trials)\b/.test(t)) return 'mx';
  if(/\bkart(ing)?\b|\bkart\s*track\b/.test(t)) return 'kart';
  if(/\bdrag\s*rac|\bnitro\b|\btop\s*fuel\b|\bnhra\b/.test(t)) return 'drag';
  if(/\boff[- ]?road|\bdesert\s+(race|classic|showdown|raid)\b|\bdakar\b|\bbaja\b|\bhare\s*scramble|\bcross\s*country\b/.test(t)) return 'offroad';
  if(/\brally\b/.test(t) && !/\b(lemons|hell\s*on\s*wheels|land\s*of\s*lincolns|24\s*hours)/i.test(t)) return 'offroad';
  if(/\benduro\b/.test(t) && !/\b(imsa|porsche|usac|wec|sportscar|grand\s*prix|sprint|wrl|lemons|enduro\s*cup\b)/i.test(t)) return 'offroad';
  if(/\bdrift(ing)?\b|\btandem\s*battle\b|\bformula\s*d(rift)?\b/.test(t)) return 'drift';
  return null;
}
function _resolveEventDiscGlobal(e, facSpecialty){
  _ensureGlobalOrgMaps();
  // The pipeline's per-event stamp (persistent_fixes venue-calendar rules)
  // is authoritative when present — venue feeds carry car/kart events under
  // moto-tagged orgs, and only the server side knows those corrections.
  if(e.discipline) return e.discipline;
  var orgD = _ORG_DISC_GLOBAL[e.org_id] || '';
  var orgSpecialty = _SPECIALTY_DISCS_GLOBAL[orgD] ? orgD : null;
  var venueRetag = (orgD === 'venue') ? _venueRetagGlobal(e) : null;
  return venueRetag || _sniffEventDiscGlobal(e) || orgSpecialty || facSpecialty || orgD || '';
}
// Cache by discF so repeated map moves don't rebuild the matching set.
var _matchingFacByDisc = {};
function _facilityHasUpcomingForDisc(f){
  if(discF === 'all') return true;
  if(f.cat === 'publicroad') return false;
  // Cache check
  var cache = _matchingFacByDisc[discF];
  if(cache && cache._key === (window.GARA_EVENTS && window.GARA_EVENTS.generated_at)){
    return !!cache.set[f.n];
  }
  // Build set for this discF
  cache = {_key: (window.GARA_EVENTS && window.GARA_EVENTS.generated_at), set: {}};
  var bucket = _EVENT_DISC_BUCKETS_GLOBAL[discF];
  var isTrackType = _TRACK_TYPE_DISCS[discF];
  FACILITIES.forEach(function(fac){
    if(fac.cat === 'publicroad') return;
    var events = _eventsForFacility(fac);
    if(!events.length) return;
    var facTps = (fac.configs||[]).map(function(c){ return c.tp; });
    var facAllSpecialty = facTps.length && facTps.every(function(tp){ return _SPECIALTY_FAC_GLOBAL[tp]; });
    var facSpecialty = facAllSpecialty ? facTps.find(function(tp){ return _SPECIALTY_FAC_GLOBAL[tp]; }) : null;
    for(var i=0; i<events.length; i++){
      var d = _resolveEventDiscGlobal(events[i], facSpecialty);
      if(!d) continue;
      if(isTrackType){
        if(d === discF) { cache.set[fac.n] = 1; break; }
      } else if(bucket){
        if(d !== 'venue' && bucket[d]) { cache.set[fac.n] = 1; break; }
      }
    }
  });
  _matchingFacByDisc[discF] = cache;
  return !!cache.set[f.n];
}
function _invalidateMatchingFacCache(){ _matchingFacByDisc = {}; }

// Race sim
function rsim(el,outline,n,h){
  el.innerHTML='';el.style.height=h+'px';
  var s=document.createElementNS('http://www.w3.org/2000/svg','svg');
  s.setAttribute('viewBox','0 0 100 60');s.style.cssText='width:100%;height:100%';
  s.setAttribute('preserveAspectRatio','xMidYMid meet');
  function mp(d,sw,op,col){var p=document.createElementNS('http://www.w3.org/2000/svg','path');
    p.setAttribute('d',d);p.setAttribute('fill','none');p.setAttribute('stroke',col||G);
    p.setAttribute('stroke-width',sw);p.setAttribute('opacity',op);
    p.setAttribute('stroke-linejoin','round');p.setAttribute('stroke-linecap','round');return p;}
  // Three-stroke layered silhouette: dim wide glow, silver mid stroke, sharp gold inline.
  s.appendChild(mp(outline,'.7','.18'));         // gold glow underneath
  s.appendChild(mp(outline,'.35','.4','#c8c8cc')); // silver body for visibility on black
  s.appendChild(mp(outline,'.18','.95'));        // crisp gold inline
  var hp=document.createElementNS('http://www.w3.org/2000/svg','path');
  hp.setAttribute('d',outline);hp.setAttribute('fill','none');hp.setAttribute('stroke','none');
  s.appendChild(hp);el.appendChild(s);
  var tl=hp.getTotalLength();if(tl<1)return function(){};
  // Racer dots: gold leader, silvers, with wider/brighter sizing
  var cols=[G,'#e0e0e4','#9a9aa0','#8b6914','#5a5a5e'];
  var rc=[];for(var i=0;i<n;i++){
    var c=document.createElementNS('http://www.w3.org/2000/svg','circle');
    c.setAttribute('r',i===0?'1.6':'1.0');c.setAttribute('fill',cols[i]||'#444');
    c.setAttribute('stroke','#000');c.setAttribute('stroke-width','.25');s.appendChild(c);
    rc.push({p:(i/n)*tl,sp:.12+Math.random()*.12,ag:.5+Math.random()*.5,d:c});
  }
  var a;function tk(){rc.forEach(function(r){r.sp+=(Math.random()-.5)*.006;
    r.sp=Math.max(.06,Math.min(.3,r.sp));r.p=(r.p+r.sp*r.ag)%tl;
    var pt=hp.getPointAtLength(r.p);r.d.setAttribute('cx',pt.x);r.d.setAttribute('cy',pt.y);});
    a=requestAnimationFrame(tk);}a=requestAnimationFrame(tk);
  return function(){cancelAnimationFrame(a);};
}

// Map
function initMap(){
  mapboxgl.accessToken='pk.eyJ1IjoiYmVudDg5IiwiYSI6ImNtbnp4MWNzNTAyNGgycG9sbmlkcTF6dDIifQ.JaCnM8rBWCzKt_HD2fSdUQ';

  function ensureSat(){
    if(mapSat)return;
    mapSat=new mapboxgl.Map({container:'map-sat',style:'mapbox://styles/mapbox/standard-satellite',
      center:map.getCenter(),zoom:map.getZoom(),pitch:map.getPitch(),bearing:map.getBearing(),
      antialias:true,maxBounds:[[-170,17],[-60,72]],minZoom:3,maxZoom:20,interactive:false,
      config:{basemap:{
        lightPreset:'day',
        showPedestrianRoads:false,
        showPointOfInterestLabels:false,
        showTransitLabels:false,
        showRoadLabels:true
      }}});
    mapSat.on('style.load',function(){
      try{mapSat.setConfigProperty('basemap','lightPreset','day');}catch(e){}
      mapSat.setFog({color:'rgb(22,22,25)','high-color':'rgb(40,40,45)','horizon-blend':.03,'star-intensity':.02,'space-color':'rgb(0,0,0)'});
    });
    mapSat.on('load',function(){
      mapSat.addSource('mapbox-dem',{type:'raster-dem',url:'mapbox://mapbox.mapbox-terrain-dem-v1',tileSize:512,maxzoom:14});
      mapSat.setTerrain({source:'mapbox-dem',exaggeration:1.3});
      satReady=true;
      setTimeout(function(){
        var ft=gf();
        var geo={type:'FeatureCollection',features:ft.map(function(t){
          return {type:'Feature',geometry:{type:'Point',coordinates:[t.lo,t.la]},properties:{name:t.n}};
        })};
        mapSat.addSource('tracks-sat',{type:'geojson',data:geo});
        mapSat.addLayer({id:'sat-dots',type:'circle',source:'tracks-sat',
          paint:{'circle-color':'#c9a84c','circle-radius':['interpolate',['linear'],['zoom'],3,3,8,5,14,8],
            'circle-opacity':.9,'circle-stroke-width':2,'circle-stroke-color':'#000','circle-stroke-opacity':.7}});
        // Track-name labels on the satellite map. Gold to match the
        // dots, fade in 10.5 -> 11.5 alongside the flashlight mask
        // revealing the satellite imagery on the dark map above.
        mapSat.addLayer({id:'track-labels-sat',type:'symbol',source:'tracks-sat',
          layout:{'text-field':['get','name'],'text-size':11,'text-offset':[0,1.4],
            'text-anchor':'top','text-optional':true,'text-allow-overlap':false,
            'text-max-width':10,'text-font':['Open Sans Bold','Arial Unicode MS Bold']},
          paint:{'text-color':'#c9a84c','text-halo-color':'#000','text-halo-width':1.5,
            'text-opacity':['interpolate',['linear'],['zoom'],10.5,0,11.5,1,16,1]}});
      },600);
    });
  }

  // DARK MAP — on top, interactive, gets masked to reveal satellite
  // maxBounds widened from [-130,22..-62,52] to [-170,17..-60,72] so AK + HI + PR tracks are reachable.
  // cooperativeGestures left OFF -- one-finger pan stays (per user feedback).
  // Locked to flat top-down: pitch:0, bearing:0, no drag-rotate or pitch
  // gestures. Selecting a track no longer tilts the camera either (see selTk).
  map=new mapboxgl.Map({container:'map',style:'mapbox://styles/mapbox/dark-v11',
    center:[-95,38],zoom:3.8,pitch:0,bearing:0,antialias:true,
    maxBounds:[[-170,17],[-60,72]],minZoom:3,maxZoom:20,
    dragRotate:false,pitchWithRotate:false,touchPitch:false,touchZoomRotate:true});
  // Belt-and-suspenders: disable rotate/pitch handlers explicitly so a touch
  // gesture pattern can't sneak the camera off the overhead lock.
  if(map.dragRotate)map.dragRotate.disable();
  if(map.touchZoomRotate && map.touchZoomRotate.disableRotation) map.touchZoomRotate.disableRotation();
  if(map.touchPitch && map.touchPitch.disable) map.touchPitch.disable();
  map.addControl(new mapboxgl.NavigationControl({showCompass:true,showZoom:true}),'bottom-right');

  // ── Lazy pie-chart sprite generator ──────────────────────────────────
  // The cluster-pies symbol layer references icon-image names like
  // "pie-3-2-0-0-1-0-0-0" -- one slot per discipline count. When Mapbox
  // tries to render a name that isn't loaded, this handler decodes the
  // numbers, paints a pie chart onto a canvas, and registers it. From
  // then on Mapbox renders the sprite natively (same tile-space
  // positioning as a native circle bubble).
  var _PIE_DISCIPLINES = ['moto','auto','mx','supermoto','kart','drag','drift','offroad'];
  var _PIE_COLORS = {
    moto:      '#e86b4e',
    auto:      '#5aa9e6',
    mx:        '#8fbc4e',
    supermoto: '#ff8c4e',
    kart:      '#f5d445',
    drag:      '#e84e8f',
    drift:     '#b36fe8',
    offroad:   '#c08050'
  };
  function _buildPieSprite(counts){
    // Canvas is needed for drawing but Mapbox addImage wants an
    // ImageData / ImageBitmap / { width, height, data } object -- NOT
    // an HTMLCanvasElement (silently fails in some Mapbox versions).
    var SIZE = 64;
    var canvas = document.createElement('canvas');
    canvas.width = SIZE; canvas.height = SIZE;
    var ctx = canvas.getContext('2d');
    var total = counts.reduce(function(a,b){return a+b;}, 0);
    var cx = SIZE/2, cy = SIZE/2, r = SIZE/2 - 2;

    if(total <= 0){
      ctx.beginPath();
      ctx.arc(cx, cy, r, 0, Math.PI*2);
      ctx.fillStyle = '#c9a84c';
      ctx.fill();
    } else {
      var start = -Math.PI/2;  // 12 o'clock
      for(var i=0;i<counts.length;i++){
        if(counts[i] <= 0) continue;
        var slice = (counts[i] / total) * Math.PI * 2;
        ctx.beginPath();
        ctx.moveTo(cx, cy);
        ctx.arc(cx, cy, r, start, start + slice);
        ctx.closePath();
        ctx.fillStyle = _PIE_COLORS[_PIE_DISCIPLINES[i]] || '#c9a84c';
        ctx.fill();
        start += slice;
      }
    }
    // Outer dark stroke so slice edges read against the basemap.
    ctx.beginPath();
    ctx.arc(cx, cy, r, 0, Math.PI*2);
    ctx.lineWidth = 1.5;
    ctx.strokeStyle = 'rgba(0,0,0,.6)';
    ctx.stroke();
    // Inner black disc -- backdrop for the count label.
    ctx.beginPath();
    ctx.arc(cx, cy, r * 0.5, 0, Math.PI*2);
    ctx.fillStyle = 'rgba(0,0,0,.88)';
    ctx.fill();
    return ctx.getImageData(0, 0, SIZE, SIZE);
  }
  map.on('styleimagemissing', function(e){
    var id = e.id;
    if(!id || id.indexOf('pie-') !== 0) return;
    if(map.hasImage(id)) return;
    var parts = id.slice(4).split('-').map(function(s){return parseInt(s,10) || 0;});
    while(parts.length < 8) parts.push(0);
    parts = parts.slice(0, 8);
    try{
      var imgData = _buildPieSprite(parts);
      map.addImage(id, imgData, { pixelRatio: 2 });
    }catch(err){
      try{ console.warn('gara: addImage failed for', id, err); }catch(e2){}
    }
  });

  // No moveend→buildCar binding. Removed 2026-05-24 — the carousel is
  // long gone, so buildCar's only side effect is updating #hcount text.
  // Since #hcount is filter-aware (not viewport-aware), the displayed
  // count doesn't change on pan/zoom — running gf() + 491 facility
  // bounds-checks per pan was killing desktop perf for zero UX benefit.
  // buildCar still runs on filter changes via refresh().

  map.on('style.load',function(){
    map.setFog({color:'rgb(5,5,5)','high-color':'rgb(12,12,12)','horizon-blend':.05,'star-intensity':.02,'space-color':'rgb(0,0,0)'});
    map.getStyle().layers.forEach(function(l){
      if(l.id.includes('road')&&l.type==='line'){
        try{map.setPaintProperty(l.id,'line-color',G);map.setPaintProperty(l.id,'line-opacity',.45);}catch(e){}
      }
    });
  });

  // Sync dark map camera to satellite map every frame so the sat
  // layer pans in lockstep with the dark map above it. mapSat is
  // lazy-created at zoom > 10.5; below that, this handler is a free
  // no-op (the if-guard returns immediately when mapSat is null), so
  // there's no perf cost for the common low-zoom case.
  function syncSat(){
    if(mapSat&&satReady)mapSat.jumpTo({center:map.getCenter(),zoom:map.getZoom(),pitch:map.getPitch(),bearing:map.getBearing()});
  }
  map.on('move', syncSat);
  // Lazy-create satellite map when approaching transition zone
  map.on('zoom',function(){if(map.getZoom()>9&&!mapSat)ensureSat();});

  // CSS mask on the CANVAS ONLY — markers stay visible
  var darkEl=null;
  function getDarkCanvas(){
    if(!darkEl)darkEl=document.querySelector('#map .mapboxgl-canvas');
    return darkEl;
  }
  function updMask(){
    var cv=getDarkCanvas();
    if(!cv)return;
    var z=map.getZoom();
    if(z<11){
      cv.style.maskImage='none';
      cv.style.webkitMaskImage='none';
      cv.style.opacity='1';
    }else if(z>14){
      cv.style.opacity='0';
    }else{
      cv.style.opacity='1';
      var progress=(z-11)/3;
      var pct=Math.max(0,progress*100);
      var edge=Math.min(100,pct+25);
      // Center the flashlight aperture on the cursor. cursorPct starts at
      // 50/50 (canvas center) and is updated by the mousemove handler below;
      // on mouseleave it decays back to center so the hole isn't stuck in a
      // corner when the user isn't on the map.
      var cx=cursorPct.x.toFixed(1),cy=cursorPct.y.toFixed(1);
      var g='radial-gradient(circle at '+cx+'% '+cy+'%, transparent '+pct.toFixed(1)+'%, rgba(0,0,0,0.4) '+(pct+10).toFixed(1)+'%, black '+edge.toFixed(1)+'%)';
      cv.style.maskImage=g;
      cv.style.webkitMaskImage=g;
    }
  }
  // Cursor position as a percentage of the map-wrap bounding box. Defaults
  // to center so behavior at page load matches the old "hole centered" look.
  var cursorPct={x:50,y:50};
  var mapWrap=document.getElementById('map-wrap');
  mapWrap.addEventListener('mousemove',function(e){
    var rect=mapWrap.getBoundingClientRect();
    cursorPct.x=((e.clientX-rect.left)/rect.width)*100;
    cursorPct.y=((e.clientY-rect.top)/rect.height)*100;
    qMask();
  });
  mapWrap.addEventListener('mouseleave',function(){
    cursorPct.x=50;cursorPct.y=50;
    qMask();
  });
  // Use requestAnimationFrame for smoother updates
  var maskRaf=null;
  function qMask(){if(!maskRaf)maskRaf=requestAnimationFrame(function(){maskRaf=null;updMask();});}
  map.on('zoom',qMask);
  map.on('move',qMask);
  map.on('moveend',updMask);

  map.on('load',function(){
    // No terrain on dark map — saves a full DEM tile set
    // Satellite map handles terrain when it loads
    var ls=map.getStyle().layers;var li=ls.find(function(l){return l.type==='symbol'&&l.layout&&l.layout['text-field'];});
    map.addLayer({id:'3d-buildings',source:'composite','source-layer':'building',filter:['==','extrude','true'],type:'fill-extrusion',minzoom:14,
      paint:{'fill-extrusion-color':'#0a0a0a','fill-extrusion-height':['interpolate',['linear'],['zoom'],14,0,14.05,['get','height']],
        'fill-extrusion-base':['interpolate',['linear'],['zoom'],14,0,14.05,['get','min_height']],'fill-extrusion-opacity':.5}
    },li?li.id:undefined);
    addMkrs();
    // No auto-select — open wide over the US (center:[-95,38], zoom:3.8)
    // so the user sees the full map of tracks before drilling in.
  });
}

var satDotsAdded=false;
function addMkrsToSat(){
  if(!mapSat||satDotsAdded)return;
  var ft=gf();
  var geo={type:'FeatureCollection',features:ft.map(function(t){
    return {type:'Feature',geometry:{type:'Point',coordinates:[t.lo,t.la]},properties:{name:t.n}};
  })};
  if(!mapSat.getSource('tracks-sat')){
    mapSat.addSource('tracks-sat',{type:'geojson',data:geo});
    mapSat.addLayer({id:'sat-dots',type:'circle',source:'tracks-sat',
      paint:{'circle-color':'#c9a84c',
        'circle-radius':['interpolate',['linear'],['zoom'],3,3,8,5,14,8],
        'circle-opacity':['interpolate',['linear'],['zoom'],12,0,13.5,1],
        'circle-stroke-width':2,'circle-stroke-color':'#000',
        'circle-stroke-opacity':['interpolate',['linear'],['zoom'],12,0,13.5,.8]}});
    // Track-name labels on the SAT map. Gold to match the sat-dots,
    // black halo for readability against satellite imagery. Fades in
    // between zoom 11 and 12 -- the same range where the dark map's
    // flashlight mask reveals satellite, so labels and sat appear
    // together.
    mapSat.addLayer({id:'track-labels-sat',type:'symbol',source:'tracks-sat',
      layout:{'text-field':['get','name'],'text-size':11,'text-offset':[0,1.4],
        'text-anchor':'top','text-optional':true,'text-allow-overlap':false,
        'text-max-width':10,'text-font':['Open Sans Bold','Arial Unicode MS Bold']},
      paint:{'text-color':'#c9a84c','text-halo-color':'#000','text-halo-width':1.5,
        'text-opacity':['interpolate',['linear'],['zoom'],10.5,0,11.5,1,16,1]}});
  }
  satDotsAdded=true;
}

function addMkrs(){
  var ft=gf();
  // GeoJSON source + circle layer — GPU rendered, handles thousands.
  // Dot color is now keyed on DISCIPLINE (what kind of racing happens at
  // this facility), not on the physical track-type. A road-course that
  // hosts motorcycle racing comes up red-orange (moto); the same shape
  // hosting car racing comes up blue (auto). MX, supermoto, kart, drag,
  // drift, offroad are disciplines in their own right.
  function _trackDiscipline(t){
    // Mode of disciplines among this facility's upcoming events.
    var evs = (typeof _eventsForFacility === 'function') ? (_eventsForFacility(t)||[]) : [];
    var counts = {};
    evs.forEach(function(e){
      var d = e.discipline || (typeof _orgDisciplineFor === 'function' ? _orgDisciplineFor(e.org_id) : null);
      if(d && d !== 'venue' && d !== 'both') counts[d] = (counts[d]||0) + 1;
    });
    var best=null, bestN=0;
    for(var k in counts){ if(counts[k] > bestN){ bestN = counts[k]; best = k; } }
    if(best) return best;
    // Fallback: derive discipline from physical track-type when no events
    // tell us. Road courses default to 'auto' (most US road circuits run
    // car racing more often than moto).
    if(t.tp==='mx') return 'mx';
    if(t.tp==='kart') return 'kart';
    if(t.tp==='drag') return 'drag';
    if(t.tp==='supermoto') return 'supermoto';
    if(t.tp==='offroad') return 'offroad';
    if(t.tp==='oval') return 'auto';
    return 'auto';
  }
  // Stamp `uc` (upcoming event count) + `nd` (days until the next
  // upcoming event) per facility so paint expressions can drive a "soon"
  // halo and the carousel can sort by urgency. Pure read of cached
  // events — no network, no DOM.
  var _today = new Date(); _today.setHours(0,0,0,0);
  function _eventStats(t){
    var evs = (typeof _eventsForFacility === 'function') ? (_eventsForFacility(t)||[]) : [];
    var nd = 999;
    if(evs.length){
      var ds = evs[0].date_start || evs[0].date_end || '';
      if(ds && ds.length >= 10){
        var d0 = new Date(ds.slice(0,4)+'-'+ds.slice(5,7)+'-'+ds.slice(8,10)+'T00:00:00');
        nd = Math.max(0, Math.round((d0 - _today) / 86400000));
      }
    }
    return { uc: evs.length, nd: nd };
  }
  var geojson={type:'FeatureCollection',features:ft.map(function(t){
    var s = _eventStats(t);
    return {type:'Feature',geometry:{type:'Point',coordinates:[t.lo,t.la]},properties:{name:t.n,tp:t.tp,s:t.s,disc:_trackDiscipline(t),uc:s.uc,nd:s.nd}};
  })};
  // Discipline palette — keep in sync with #legend-panel rows.
  var DISC_COLOR_EXPR = ['match', ['get','disc'],
    'moto',      '#e86b4e',  // red-orange = motorcycle road racing
    'auto',      '#5aa9e6',  // blue       = automobile road racing
    'mx',        '#8fbc4e',  // green      = motocross / dirt
    'supermoto', '#ff8c4e',  // bright orange = supermoto
    'kart',      '#f5d445',  // yellow     = karting
    'drag',      '#e84e8f',  // pink       = drag
    'drift',     '#b36fe8',  // purple     = drift
    'offroad',   '#c08050',  // muted brown = off-road
    /* default */ '#c9a84c'];
  if(map.getSource('tracks')){
    map.getSource('tracks').setData(geojson);
  }else{
    map.addSource('tracks',{type:'geojson',data:geojson,cluster:true,clusterMaxZoom:10,clusterRadius:40,
      clusterProperties:{
        // Aggregate counts per discipline so the pie sprite can be picked
        // entirely from cluster properties -- no JS positioning needed.
        moto:      ['+',['case',['==',['get','disc'],'moto'],1,0]],
        auto:      ['+',['case',['==',['get','disc'],'auto'],1,0]],
        mx:        ['+',['case',['==',['get','disc'],'mx'],1,0]],
        supermoto: ['+',['case',['==',['get','disc'],'supermoto'],1,0]],
        kart:      ['+',['case',['==',['get','disc'],'kart'],1,0]],
        drag:      ['+',['case',['==',['get','disc'],'drag'],1,0]],
        drift:     ['+',['case',['==',['get','disc'],'drift'],1,0]],
        offroad:   ['+',['case',['==',['get','disc'],'offroad'],1,0]],
      }
    });
    // CLUSTER PIE CHARTS as a Mapbox-native symbol layer.
    // icon-image is built dynamically from each cluster's disc counts, e.g.
    // "pie-3-2-0-0-1-0-0-0" = a 6-track cluster with 3 moto, 2 auto, 1 kart.
    // When the runtime hits a name that isn't loaded yet, the
    // styleimagemissing handler below lazy-generates a canvas pie sprite
    // and registers it. Mapbox positions the symbol natively in tile
    // space -- same coordinate it would have used for the old gold
    // circle bubble -- so the pie always sits where the cluster is.
    map.addLayer({id:'cluster-pies',type:'symbol',source:'tracks',filter:['has','point_count'],
      layout:{
        'icon-image':['concat','pie-',
          ['to-string',['get','moto']],'-',
          ['to-string',['get','auto']],'-',
          ['to-string',['get','mx']],'-',
          ['to-string',['get','supermoto']],'-',
          ['to-string',['get','kart']],'-',
          ['to-string',['get','drag']],'-',
          ['to-string',['get','drift']],'-',
          ['to-string',['get','offroad']]
        ],
        'icon-size':['step',['get','point_count'], 1.2,  10, 1.5,  50, 1.9],
        'icon-allow-overlap':true,
        'icon-ignore-placement':true
      }});
    // Invisible hit-target circle layer for cluster click (symbol layers
    // are harder to click reliably on touch -- this gives a generous tap
    // radius without affecting visual appearance).
    map.addLayer({id:'clusters',type:'circle',source:'tracks',filter:['has','point_count'],
      paint:{'circle-color':'#000','circle-opacity':0,
        'circle-radius':['step',['get','point_count'], 26,  10, 32,  50, 40]}});
    // Cluster count label, painted ON TOP of the pie.
    map.addLayer({id:'cluster-count',type:'symbol',source:'tracks',filter:['has','point_count'],
      layout:{
        'text-field':['get','point_count_abbreviated'],
        'text-size':['step',['get','point_count'], 14,  10, 16,  50, 18],
        'text-font':['Open Sans Bold','Arial Unicode MS Bold']
      },
      paint:{'text-color':'#fff','text-halo-color':'rgba(0,0,0,.5)','text-halo-width':1}});
    // ── "Soon" halo ──────────────────────────────────────────────
    // Soft gold aura BENEATH each track dot. Radius grows with the
    // facility's upcoming-event count; opacity scales with days-to-
    // next-event (close events = bright, far = dim, no events at all
    // = hidden by the filter). Brand gold #c9a84c, color-blind safe
    // (size + brightness, never relies on hue).
    map.addLayer({id:'track-aura',type:'circle',source:'tracks',
      filter:['all',['!',['has','point_count']],['>',['get','uc'],0]],
      paint:{
        'circle-color':'#c9a84c',
        'circle-blur':0.8,
        'circle-radius':['interpolate',['linear'],['zoom'],
          3,  ['interpolate',['linear'],['get','uc'], 1,4,  5,7,  15,11, 30,16],
          8,  ['interpolate',['linear'],['get','uc'], 1,7,  5,11, 15,17, 30,24],
          14, ['interpolate',['linear'],['get','uc'], 1,12, 5,18, 15,28, 30,40]
        ],
        'circle-opacity':['interpolate',['linear'],['get','nd'],
          0, 0.75,  7, 0.55,  30, 0.20,  90, 0.0
        ]
      }});
    // Individual track dots — discipline-coded color (sits ABOVE the halo)
    map.addLayer({id:'track-dots',type:'circle',source:'tracks',filter:['!',['has','point_count']],
      paint:{'circle-color':DISC_COLOR_EXPR,'circle-radius':['interpolate',['linear'],['zoom'],3,3,8,5,14,10,17,14],
        'circle-opacity':.9,'circle-stroke-width':2,'circle-stroke-color':'#000','circle-stroke-opacity':.7}});
    // Track-name labels on the DARK map -- fade in EARLY (zoom 4 -> 5)
    // so the dot is identifiable while panning at country/region level.
    // Stays through zoom 11; fades out 11 -> 12 where the satellite
    // tiles take over (the sat map has its own labels via
    // track-labels-sat). text-size grows slightly with zoom so labels
    // don't crowd at country view but read well as the user zooms in.
    map.addLayer({id:'track-labels-dark',type:'symbol',source:'tracks',filter:['!',['has','point_count']],
      layout:{'text-field':['get','name'],
        'text-size':['interpolate',['linear'],['zoom'], 4,9, 7,10, 11,12],
        'text-offset':[0,1.4],
        'text-anchor':'top','text-optional':true,'text-allow-overlap':false,
        'text-max-width':10,'text-font':['Open Sans Bold','Arial Unicode MS Bold']},
      paint:{'text-color':'#c9a84c','text-halo-color':'#000','text-halo-width':1.5,
        'text-opacity':['interpolate',['linear'],['zoom'], 3,0,  4,0.7,  5,0.9,  11,0.9,  12,0]}});
    // Invisible hit-target layer ABOVE the visible dots so taps register on a
    // generous 22px radius (~44pt iOS-recommended touch target at z 14+).
    // circle-opacity:0 keeps it invisible; click/hover events still fire on it.
    map.addLayer({id:'track-dots-hit',type:'circle',source:'tracks',filter:['!',['has','point_count']],
      paint:{'circle-color':'#000','circle-opacity':0,'circle-radius':
        ['interpolate',['linear'],['zoom'],3,12,8,16,14,22,17,26]}});
    // Track-name labels live on the SATELLITE map, not the dark map --
    // they only need to appear at zoom > 11 where the dark map's
    // flashlight mask reveals satellite tiles underneath. Adding them on
    // the satellite source matches the visual layer the user actually
    // sees at that zoom (gold name over satellite imagery).
    // See addMkrsToSat for the layer definition.
    // Hover + click bound to the generous hit-target layer so the user only
    // needs to land within ~22px of a dot, not on the 5-10px visible disc.
    map.on('mouseenter','track-dots-hit',function(){map.getCanvas().style.cursor='pointer';});
    map.on('mouseleave','track-dots-hit',function(){map.getCanvas().style.cursor='';});
    map.on('click','track-dots-hit',function(e){
      var name=e.features[0].properties.name;
      var f=FACILITIES.find(function(x){return x.n===name;});
      if(f)selTk(f);
    });
    // Click cluster to zoom in
    map.on('click','clusters',function(e){
      var cid=e.features[0].properties.cluster_id;
      map.getSource('tracks').getClusterExpansionZoom(cid,function(err,z){
        if(err)return;
        map.flyTo({center:e.features[0].geometry.coordinates,zoom:z+0.5,duration:800,essential:true});
      });
    });
    // Popup on hover — bound to the hit-target layer so it fires anywhere
    // within ~22px of a dot, not only when the cursor is on the visible disc.
    var popup=new mapboxgl.Popup({closeButton:false,closeOnClick:false,className:'track-popup',offset:12});
    map.on('mouseenter','track-dots-hit',function(e){
      var feat=e.features[0];
      var facility=FACILITIES.find(function(x){return x.n===feat.properties.name;});
      var badge=(facility&&facility.configs.length>1)?' <span style="color:#666;font-size:9px">+'+(facility.configs.length-1)+'</span>':'';
      popup.setLngLat(feat.geometry.coordinates).setHTML('<div style="font-family:Oswald,sans-serif;font-size:11px;letter-spacing:1px;color:'+G+';text-transform:uppercase;padding:2px 4px">'+feat.properties.name+badge+'</div>').addTo(map);
    });
    map.on('mouseleave','track-dots-hit',function(){popup.remove();});
  }
  var fcEl=document.getElementById('fcount');
  if(fcEl)fcEl.textContent=ft.length+'/'+FACILITIES.length;
  addMkrsToSat();
}

// ── OSM geometry fetching ──
// Pulls real track polyline from OpenStreetMap, converts to SVG path,
// updates length, re-renders sim. Caches per-track in localStorage.
// Cache version bumped to v4: prior versions cached pre-fix Overpass results
// that were silently overwriting authoritative stored lengths on click. v4
// drops any old entries, forcing a re-fetch through the new guardrail that
// only allows length overwrites for high-confidence sources.
var osmCache={};
try{
  osmCache=JSON.parse(localStorage.getItem('gara_osm_v4')||'{}');
  // One-time wipe of legacy keys so users see fresh data after the click-bug fix
  localStorage.removeItem('gara_osm_v2');
  localStorage.removeItem('gara_osm_v3');
}catch(e){}

function haversine(lat1,lng1,lat2,lng2){
  var R=6371000,p1=lat1*Math.PI/180,p2=lat2*Math.PI/180;
  var dp=(lat2-lat1)*Math.PI/180,dl=(lng2-lng1)*Math.PI/180;
  var a=Math.sin(dp/2)*Math.sin(dp/2)+Math.cos(p1)*Math.cos(p2)*Math.sin(dl/2)*Math.sin(dl/2);
  return R*2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));
}

// Convert lat/lng polyline to a normalized SVG path (0-100 x, 0-60 y) for rsim()
function polylineToSVG(coords){
  var lats=coords.map(function(c){return c[1];});
  var lngs=coords.map(function(c){return c[0];});
  var minLa=Math.min.apply(null,lats),maxLa=Math.max.apply(null,lats);
  var minLn=Math.min.apply(null,lngs),maxLn=Math.max.apply(null,lngs);
  // Aspect-correct: longitude shrinks at high latitudes
  var avgLat=(minLa+maxLa)/2;
  var lngScale=Math.cos(avgLat*Math.PI/180);
  var w=(maxLn-minLn)*lngScale,h=maxLa-minLa;
  if(w<1e-9||h<1e-9)return null;
  // Fit to viewBox (0..100 x, 0..60 y) with 6px margin
  var vbW=88,vbH=48,padX=6,padY=6;
  var sx=vbW/w,sy=vbH/h,s=Math.min(sx,sy);
  var ox=padX+(vbW-w*s)/2,oy=padY+(vbH-h*s)/2;
  var d='';
  coords.forEach(function(c,i){
    var x=ox+(c[0]-minLn)*lngScale*s;
    var y=oy+(maxLa-c[1])*s;  // flip Y (north = up)
    d+=(i===0?'M':' L')+x.toFixed(1)+','+y.toFixed(1);
  });
  return d;
}

// Stitch ways that meet end-to-end within tolerance into continuous polylines.
// OSM commonly splits a single circuit into several ways at tagging boundaries;
// without merging them the UI only sees one segment — the "fractured track" bug.
function mergeWays(ways,tolM){
  var pool=ways.map(function(w){return w.geometry.slice();}).filter(function(g){return g.length>=2;});
  var groups=[];
  while(pool.length){
    var cur=pool.shift();
    var changed=true;
    while(changed&&pool.length){
      changed=false;
      for(var i=0;i<pool.length;i++){
        var other=pool[i];
        var cs=cur[0],ce=cur[cur.length-1];
        var os=other[0],oe=other[other.length-1];
        if(haversine(ce.lat,ce.lon,os.lat,os.lon)<tolM){
          cur=cur.concat(other.slice(1));pool.splice(i,1);changed=true;break;
        }
        if(haversine(ce.lat,ce.lon,oe.lat,oe.lon)<tolM){
          cur=cur.concat(other.slice(0,-1).reverse());pool.splice(i,1);changed=true;break;
        }
        if(haversine(cs.lat,cs.lon,oe.lat,oe.lon)<tolM){
          cur=other.concat(cur.slice(1));pool.splice(i,1);changed=true;break;
        }
        if(haversine(cs.lat,cs.lon,os.lat,os.lon)<tolM){
          cur=other.slice().reverse().concat(cur.slice(1));pool.splice(i,1);changed=true;break;
        }
      }
    }
    groups.push(cur);
  }
  return groups;
}
function _groupLen(g){
  var m=0;
  for(var i=1;i<g.length;i++)m+=haversine(g[i-1].lat,g[i-1].lon,g[i].lat,g[i].lon);
  return m;
}
function _groupCentroid(g){
  var la=0,lo=0;
  for(var i=0;i<g.length;i++){la+=g[i].lat;lo+=g[i].lon;}
  return {la:la/g.length,lo:lo/g.length};
}

function fetchOSM(track,cb){
  var key=track.n+'|'+track.la.toFixed(3)+','+track.lo.toFixed(3);
  if(osmCache[key]){cb(osmCache[key]);return;}
  // If this track has a pre-baked GPS trace (from gara_pull_gps_traces.py),
  // skip Overpass entirely and return it as a single clean polyline.
  var baked=track.path;
  if(baked && baked.length>=10){
    // baked is [[lat,lon],...] — coords consumer wants [lon,lat]
    var bakedCoords=baked.map(function(p){return [p[1],p[0]];});
    // Compute length from the baked trace
    var bakedMeters=0;
    for(var bi=1;bi<baked.length;bi++){
      bakedMeters+=haversine(baked[bi-1][0],baked[bi-1][1],baked[bi][0],baked[bi][1]);
    }
    var result={coords:bakedCoords,miles:(bakedMeters/1609.34).toFixed(2),source:'gps_trace'};
    osmCache[key]=result;
    try{localStorage.setItem('gara_osm_v4',JSON.stringify(osmCache));}catch(e){}
    cb(result);
    return;
  }
  // Pull ways AND member ways of nearby route/site relations. Many circuits
  // (Road America, VIR, Watkins Glen) are tagged as relations combining several
  // ways — fetching just ways misses the relation-level connectivity.
  var q='[out:json][timeout:20];('+
    'way(around:3000,'+track.la+','+track.lo+')[highway=raceway];'+
    'way(around:3000,'+track.la+','+track.lo+')[leisure=track][sport~"motor|karting|motocross|drag"];'+
    'way(around:3000,'+track.la+','+track.lo+')[leisure=pitch][sport~"motor|karting|motocross|drag"];'+
    'relation(around:3000,'+track.la+','+track.lo+')[type=site][site~"raceway|circuit"];'+
    'relation(around:3000,'+track.la+','+track.lo+')[type=route][route~"road|raceway"];'+
    ');(._;>;);out geom;';
  fetch('https://overpass-api.de/api/interpreter',{method:'POST',body:'data='+encodeURIComponent(q)})
    .then(function(r){return r.json();})
    .then(function(data){
      var ways=(data.elements||[]).filter(function(w){return w.type==='way'&&w.geometry&&w.geometry.length>=2;});
      if(!ways.length){cb(null);return;}
      // Stitch: try tight tolerance first for clean circuits, then fall back to
      // looser tolerance for tracks with larger gaps between ways. Two-pass
      // approach avoids false merges on tightly-mapped tracks.
      var groups=mergeWays(ways,50);
      if(groups.length>2){
        // Multiple fragments left — try again with 100m. Works on the stubborn
        // circuits (Barber, Mid-Ohio) without polluting clean ones.
        var loose=mergeWays(ways,100);
        if(loose.length<groups.length)groups=loose;
      }
      if(!groups.length){cb(null);return;}
      // Pick the group that best represents this config: score = length / (proximity + 100).
      // Long + close to the config centroid wins; short-and-far (pit lanes, neighbors) loses.
      var best=null,bestScore=-Infinity;
      groups.forEach(function(g){
        if(g.length<4)return;
        var len=_groupLen(g);
        if(len<40)return; // toss stubs (<40m)
        var c=_groupCentroid(g);
        var d=haversine(track.la,track.lo,c.la,c.lo);
        var score=len/(d+100);
        if(score>bestScore){bestScore=score;best=g;}
      });
      if(!best){cb(null);return;}
      var coords=best.map(function(p){return [p.lon,p.lat];});
      var meters=_groupLen(best);
      var result={coords:coords,miles:(meters/1609.34).toFixed(2)};
      osmCache[key]=result;
      try{localStorage.setItem('gara_osm_v4',JSON.stringify(osmCache));}catch(e){}
      cb(result);
    })
    .catch(function(){cb(null);});
}

// Render stats row — reused by selTk, setConfig, and the OSM upgrade callback
function renderStats(c){
  // Normalize obvious "undefined / missing" placeholders so they display as
  // a clean em-dash instead of the literal "UNDEFINED" or "?"
  function clean(v){
    if(v === null || v === undefined) return '—';
    var s = String(v).trim();
    if(!s || s === '?' || s === '-' || s.toUpperCase() === 'UNDEFINED') return '—';
    return s;
  }
  // Venue-type entries (parking lots, fairgrounds, college campuses used for
  // autocross) don't have a meaningful track length or fixed turn count —
  // each event lays out a different cone course.
  var isVenue=(c.tp==='venue');
  // Off-road / rally events use point-to-point courses, not a fixed loop.
  var isOffroad=(c.tp==='offroad' || c.tp==='rally');
  var rows;
  if(isVenue){
    rows=[['Surface','Paved lot',0],['Layout','Varies per event',0],['Elev.',clean(c.el),0],['Type',c.tp,1]];
  } else if(isOffroad){
    rows=[['Course',clean(c.l) === '—' ? 'Point-to-point' : clean(c.l),0],['Terrain','Off-road',0],['Elev.',clean(c.el),0],['Type',c.tp,1]];
  } else {
    rows=[['Length',clean(c.l),0],['Turns',clean(c.tu),0],['Elev.',clean(c.el),0],['Type',c.tp,1]];
  }
  return rows.map(function(x){
    return '<div><div style="font-family:Oswald,sans-serif;font-weight:500;font-size:8px;color:var(--s-dim);text-transform:uppercase;letter-spacing:1.5px;margin-bottom:2px">'+x[0]+'</div><div style="font-family:Oswald,sans-serif;font-weight:600;font-size:14px;color:'+(x[2]?'var(--g)':'#fff')+';text-transform:uppercase">'+x[1]+'</div></div>';
  }).join('');
}

// Render config switcher for a facility with multiple layouts.
// Hidden when there's only one config — no visual noise for simple facilities.
function renderConfigSwitcher(facility){
  var host=document.getElementById('sp-cfg');
  if(!host)return;
  if(facility.configs.length<=1){host.innerHTML='';host.style.display='none';return;}
  // empty string lets the stylesheet's display:flex + flex-wrap take effect;
  // the old hardcoded 'block' was killing the wrap (chips stacked vertically).
  host.style.display='';
  host.innerHTML=facility.configs.map(function(c,i){
    return '<div class="cfg-chip'+(i===facility._activeConfig?' ac':'')+'" data-i="'+i+'">'+c._label+'</div>';
  }).join('');
  host.querySelectorAll('.cfg-chip').forEach(function(el){
    el.addEventListener('click',function(){setConfig(facility,parseInt(this.dataset.i));});
  });
}

// Swap the facility's active config — copies that config's props onto the
// facility object so the rest of the app sees the right length/turns/outline.
function setConfig(facility,i){
  if(i===facility._activeConfig)return;
  facility._activeConfig=i;
  var c=facility.configs[i];
  facility.l=c.l;facility.tu=c.tu;facility.el=c.el;facility.sg=c.sg;
  facility.tp=c.tp;facility.o=c.o;
  // Use the config's actual lat/lo for OSM lookup — turns/sub-features
  // may sit at slightly different coords than the facility centroid.
  facility._cfgLa=c.la;facility._cfgLo=c.lo;
  document.getElementById('sp-st').innerHTML=renderStats(facility);
  if(simClean)simClean();
  if(facility.o)simClean=rsim(document.getElementById('sp-sim'),facility.o,5,110);
  renderConfigSwitcher(facility);
  // Re-render the events list because event filtering depends on facility.tp
  // (e.g. IMS Road Course vs IMS Oval matches different events). Without this,
  // the list goes stale until the user picks a different track.
  renderEvents(facility);
  // Re-query OSM for the new config
  fetchOSMForFacility(facility);
}

function fetchOSMForFacility(facility){
  // Skip Overpass entirely for facility types where OSM either has no useful
  // data or where its 3km radius scoop returns nonsense:
  //   - venue: parking lots, college campuses, fairgrounds, stadiums
  //   - supermoto/kart at small private facilities: OSM usually has no
  //     tagged way for them, falls back to surrounding roads
  //   - rallycross/offroad/rally: courses set up per-event, no fixed track
  // For these, if facility.l is already set we keep it; otherwise show "—".
  var skip_osm = ['venue','rallycross','offroad','rally'].indexOf(facility.tp) >= 0;
  if(!skip_osm && (facility.tp==='supermoto' || facility.tp==='kart')){
    // Allow OSM only if facility name suggests a tagged motorsports park
    var nameLow = (facility.n||'').toLowerCase();
    if(!/(raceway|speedway|park|circuit|complex|kartway|kart\s?plex)/.test(nameLow)){
      skip_osm = true;
    }
  }
  if(skip_osm){
    if(!facility.l || facility.l === '-' || facility.l === '—'){
      facility.l = '—';
      var cfg0 = facility.configs && facility.configs[facility._activeConfig];
      if(cfg0) cfg0.l = '—';
    }
    var stEl = document.getElementById('sp-st');
    if(stEl) stEl.innerHTML = renderStats(facility);
    return;
  }
  // Public roads already have their real polyline baked in (from the Python
  // road puller). Don't hit Overpass — use the local geom directly.
  if(facility._publicRoad){
    var cfg0=facility.configs[facility._activeConfig];
    var rawGeom=cfg0._geom||facility._geom;
    if(!rawGeom||!rawGeom.length)return;
    var newPath=polylineToSVG(rawGeom);
    if(!newPath)return;
    facility.o=newPath;cfg0.o=newPath;
    if(simClean)simClean();
    simClean=rsim(document.getElementById('sp-sim'),facility.o,5,110);
    document.getElementById('sp-st').innerHTML=renderStats(facility);
    var cardEl=document.querySelector('.tc[data-n="'+CSS.escape(facility.n)+'"] [data-sim]');
    if(cardEl){cardEl.innerHTML='';rsim(cardEl,facility.o,3,100);}
    return;
  }
  var cfg=facility.configs[facility._activeConfig];
  // fetchOSM expects {n, la, lo} — build a probe from the active config
  var probe={n:cfg.n,la:cfg.la,lo:cfg.lo};
  fetchOSM(probe,function(result){
    if(!result||sel!==facility)return;
    // Length: only overwrite when (a) stored value is missing/placeholder,
    // OR (b) we got a high-confidence GPS trace. Raw Overpass returns a noisy
    // length for fractured tracks (partial laps, pit lanes, service roads
    // mixed in) and was clobbering authoritative stored values — that's the
    // "mileage changes when I click" bug. Stored values come from the track
    // operator and are trusted unless flagged otherwise via _lsrc.
    var storedL=(cfg.l||'').trim();
    var storedSrc=cfg._lsrc||facility._lsrc||'stored';
    var canReplace=(!storedL||storedL==='-'||storedL==='-mi'||storedSrc==='overpass');
    if(result.source==='gps_trace'||canReplace){
      facility.l=result.miles+' mi';cfg.l=facility.l;
      cfg._lsrc=result.source==='gps_trace'?'gps_trace':'overpass';
    }
    // Outline: same hierarchy. GPS trace always wins; raw Overpass only swaps
    // in when we have no decent silhouette to begin with (rare — Stage 2-6
    // backfill should leave very few of these).
    if(result.source==='gps_trace'){
      var newPath=polylineToSVG(result.coords);
      if(newPath){
        facility.o=newPath;cfg.o=newPath;
        if(simClean)simClean();
        simClean=rsim(document.getElementById('sp-sim'),facility.o,5,110);
        var cardEl=document.querySelector('.tc[data-n="'+CSS.escape(facility.n)+'"] [data-sim]');
        if(cardEl){cardEl.innerHTML='';rsim(cardEl,facility.o,3,100);}
      }
    }
    document.getElementById('sp-st').innerHTML=renderStats(facility);
  });
}

function selTk(t){
  // Defensive cleanup of overlay state that can get stuck and visually
  // cover the header:
  //   - #cfan (fan-chip cascade, z:1000) — sticks open on touch
  //   - #filter-scrim (z:40) + #sb.open — sticks open if the drawer/scrim
  //     fall out of sync (drawer closes via animation but scrim's .show
  //     was never removed)
  //   - body.legend-open — same idea, kill stale legend state
  var _fan = document.getElementById('cfan');
  if(_fan) _fan.classList.remove('show');
  var _scrim = document.getElementById('filter-scrim');
  if(_scrim) _scrim.classList.remove('show');
  var _sb = document.getElementById('sb');
  if(_sb) _sb.classList.remove('open');
  document.body.classList.remove('filter-open');
  document.body.classList.remove('legend-open');
  // Reset active config to primary whenever a facility is (re-)selected from
  // OUTSIDE -- but only when the caller hasn't explicitly set one. Search
  // results and chip-clicks set t._cfgIdxOverride first to keep their pick.
  if(t.configs && sel!==t && t._cfgIdxOverride==null){
    t._activeConfig=0;
  }
  if(t._cfgIdxOverride!=null){
    t._activeConfig = t._cfgIdxOverride;
    delete t._cfgIdxOverride;
  }
  sel=t;
  // If we were passed a plain config (from search), look up its facility
  if(!t.configs){
    var parent=FACILITIES.find(function(f){
      return f.configs.some(function(c){return c.n===t.n;});
    });
    if(parent){
      var cfgIdx=parent.configs.findIndex(function(c){return c.n===t.n;});
      parent._activeConfig=cfgIdx>=0?cfgIdx:0;
      sel=parent;
      t=parent;
      // Apply the selected config's props to the facility
      var c=parent.configs[parent._activeConfig];
      parent.l=c.l;parent.tu=c.tu;parent.el=c.el;parent.sg=c.sg;
      parent.tp=c.tp;parent.o=c.o;
    }
  }
  // Camera stays flat top-down on selection (per user feedback -- the old
  // pitched cinematic angle was disorienting). Honor prefers-reduced-motion
  // by skipping the flyTo animation entirely.
  var _reduceMotion = false;
  try{ _reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; }catch(e){}
  if(_reduceMotion){
    map.jumpTo({center:[t.lo,t.la],zoom:14,pitch:0,bearing:0});
  } else {
    map.flyTo({center:[t.lo,t.la],zoom:14,pitch:0,bearing:0,duration:1200,essential:false});
  }
  // After a beat, scroll the matching card into the centre of the carousel
  // so the user can see which one they just picked.
  setTimeout(function(){
    var card = document.querySelector('.tc[data-n="' + (t.n||'').replace(/"/g,'\\"') + '"]');
    if(card && card.scrollIntoView){
      try{ card.scrollIntoView({behavior:_reduceMotion?'auto':'smooth', inline:'center', block:'nearest'}); }catch(e){}
    }
  }, _reduceMotion?0:600);
  // Match map lighting to what it actually looks like at the track right now.
  applyDayNightCycle(t.la,t.lo);
  var p=document.getElementById('spnl');p.classList.add('vis');
  // On mobile, new selection opens expanded so user sees details immediately.
  // They can swipe down / tap handle to collapse to the peek bar.
  if(isMobileBreakpoint())p.classList.add('expanded');
  document.getElementById('sp-n').textContent=t.n;
  document.getElementById('sp-c').textContent=(t.c?t.c+', ':'')+t.s;
  renderConfigSwitcher(t);
  document.getElementById('sp-st').innerHTML=renderStats(t);
  renderEvents(t);
  if(simClean)simClean();
  if(t.o)simClean=rsim(document.getElementById('sp-sim'),t.o,5,110);
  document.querySelectorAll('.tc').forEach(function(c){c.classList.toggle('ac',c.dataset.n===t.n);});
  var ac=document.querySelector('.tc[data-n="'+CSS.escape(t.n)+'"]');
  if(ac)ac.scrollIntoView({behavior:'smooth',inline:'center',block:'nearest'});

  fetchOSMForFacility(t);
}

/* ──────────────── Day/night cycle ────────────────
   When a track is selected, compute its local sunrise/sunset based on lat/lon
   and the current UTC time, then drive the Mapbox basemap `lightPreset`. The
   map's lighting matches what it actually looks like AT THE TRACK right now —
   morning in California renders as 'day' / 'dawn' while a track in NY at the
   same moment might show 'dusk'. Simple NOAA-ish solar calc, accurate ±10min. */
function _computeSunHoursUTC(date,lat,lon){
  // Day of year (1..366)
  var start=new Date(Date.UTC(date.getUTCFullYear(),0,0));
  var diff=date.getTime()-start.getTime();
  var day=Math.floor(diff/86400000);
  // Solar declination (approx): 23.45° * cos(2π * (day - 172) / 365)
  var declDeg=-23.45*Math.cos(2*Math.PI*(day+10)/365);
  var latR=lat*Math.PI/180;
  var decR=declDeg*Math.PI/180;
  var cosH=-Math.tan(latR)*Math.tan(decR);
  cosH=Math.max(-1,Math.min(1,cosH));
  var halfDayDeg=Math.acos(cosH)*180/Math.PI;
  // Solar noon in UTC hours: noon local → noon - lon/15 in UTC terms
  var solarNoonUTC=12-lon/15;
  return {
    sunriseUTC: solarNoonUTC - halfDayDeg/15,
    sunsetUTC:  solarNoonUTC + halfDayDeg/15
  };
}
function _lightPresetFor(lat,lon){
  var now=new Date();
  var hUTC=now.getUTCHours()+now.getUTCMinutes()/60+now.getUTCSeconds()/3600;
  var sun=_computeSunHoursUTC(now,lat,lon);
  // Normalize to a 0..24 scale (handle negative or >24 wrap)
  function norm(x){while(x<0)x+=24;while(x>=24)x-=24;return x;}
  var t=norm(hUTC), sr=norm(sun.sunriseUTC), ss=norm(sun.sunsetUTC);
  // Dawn zone: 40 min before → 40 min after sunrise. Dusk: same around sunset.
  var DAWN=0.67, DUSK=0.67;
  function within(x,center,halfWidth){
    var d=Math.abs(x-center);
    if(d>12)d=24-d;
    return d<=halfWidth;
  }
  if(within(t,sr,DAWN))return 'dawn';
  if(within(t,ss,DUSK))return 'dusk';
  // Between sunrise+dawn and sunset-dusk → day. Else night.
  // Use arc distance to decide which side of the circle we're on.
  var fromSR=norm(t-sr), fromSS=norm(t-ss);
  // If hours after sunrise < hours after sunset, we're in day (closer to sunrise just passed).
  return fromSR<fromSS ? 'day' : 'night';
}
function applyDayNightCycle(lat,lon){
  var preset=_lightPresetFor(lat,lon);
  try{
    if(map)map.setConfigProperty('basemap','lightPreset',preset);
  }catch(e){}
  try{
    if(mapSat)mapSat.setConfigProperty('basemap','lightPreset',preset);
  }catch(e){}
  return preset;
}

/* ──────────────── Weather (Open-Meteo, keyless) ────────────────
   Only useful for events within the next ~14 days — beyond that the forecast
   is meaningless and we leave the icon empty. One API call per facility covers
   every upcoming event at that facility. Cached per (lat,lon) for the session. */
var _wxCache={};
function _wxIcon(code){
  // WMO weather_code → emoji. https://open-meteo.com/en/docs#weather_variable_documentation
  if(code===0)return '\u2600\uFE0F';              // ☀ clear
  if(code>=1&&code<=2)return '\uD83C\uDF24\uFE0F'; // 🌤 mostly sunny
  if(code===3)return '\u2601\uFE0F';              // ☁ overcast
  if(code===45||code===48)return '\uD83C\uDF2B\uFE0F'; // 🌫 fog
  if(code>=51&&code<=57)return '\uD83C\uDF26\uFE0F'; // 🌦 drizzle
  if(code>=61&&code<=67)return '\uD83C\uDF27\uFE0F'; // 🌧 rain
  if(code>=71&&code<=77)return '\uD83C\uDF28\uFE0F'; // 🌨 snow
  if(code>=80&&code<=82)return '\uD83C\uDF26\uFE0F'; // 🌦 showers
  if(code>=85&&code<=86)return '\uD83C\uDF28\uFE0F'; // 🌨 snow showers
  if(code>=95)return '\u26C8\uFE0F';              // ⛈ thunder
  return '';
}
function _wxLabel(code){
  // Human-readable label for the weather_code — used in hover tooltip.
  if(code===0)return 'Clear';
  if(code===1)return 'Mostly clear';
  if(code===2)return 'Partly cloudy';
  if(code===3)return 'Overcast';
  if(code===45||code===48)return 'Fog';
  if(code>=51&&code<=55)return 'Drizzle';
  if(code===56||code===57)return 'Freezing drizzle';
  if(code===61)return 'Light rain';
  if(code===63)return 'Rain';
  if(code===65)return 'Heavy rain';
  if(code===66||code===67)return 'Freezing rain';
  if(code>=71&&code<=75)return 'Snow';
  if(code===77)return 'Snow grains';
  if(code===80)return 'Light showers';
  if(code===81)return 'Showers';
  if(code===82)return 'Heavy showers';
  if(code>=85&&code<=86)return 'Snow showers';
  if(code===95)return 'Thunderstorm';
  if(code===96||code===99)return 'Thunderstorm w/ hail';
  return 'Weather '+code;
}
function fetchWeatherForFacility(fac,cb){
  var key=fac.la.toFixed(3)+','+fac.lo.toFixed(3);
  if(_wxCache[key]){cb(_wxCache[key]);return;}
  // Open-Meteo returns up to 16 days of daily forecast for free, no key.
  var url='https://api.open-meteo.com/v1/forecast?latitude='+fac.la+'&longitude='+fac.lo+'&daily=weather_code&forecast_days=16&timezone=auto';
  fetch(url).then(function(r){return r.json();}).then(function(data){
    var map={};
    if(data&&data.daily&&data.daily.time){
      data.daily.time.forEach(function(d,i){map[d]=data.daily.weather_code[i];});
    }
    _wxCache[key]=map;
    cb(map);
  }).catch(function(){cb({});});
}
function applyWeatherIcons(fac,events,host){
  // Open-Meteo returns 16 days of forecast — use the full window. Events beyond
  // that leave the icon empty (genuinely unknowable, not a loading state).
  var today=new Date();today.setHours(0,0,0,0);
  var cutoff=new Date(today.getTime()+16*86400000);
  var anyNear=events.some(function(e){
    var d=_parseISO(e.date_start);
    return d&&d>=today&&d<=cutoff;
  });
  if(!anyNear)return;
  fetchWeatherForFacility(fac,function(wxMap){
    events.forEach(function(e,i){
      var code=wxMap[e.date_start];
      var cell=host.querySelector('.ev-wx[data-wx="'+i+'"]');
      if(!cell)return;
      if(code===undefined){
        // Beyond forecast window → faint dash so users know weather isn't
        // missing, it's just too far out.
        var d=_parseISO(e.date_start);
        if(d&&d>cutoff){
          cell.innerHTML='<span style="opacity:.28;font-size:11px">—</span>';
          cell.setAttribute('title','Beyond 16-day forecast');
        }
        return;
      }
      cell.textContent=_wxIcon(code);
      cell.setAttribute('title',_wxLabel(code));
    });
  });
}

/* ──────────────── Event matching + render ────────────────
   window.GARA_EVENTS is injected by assets/gara_events.js (pushed by the
   compliance pipeline's events/scraper.py). When a facility is selected,
   filter events to those whose raw track_name fuzzy-matches the facility. */

function _normalizeTrack(s){
  if(!s)return '';
  return s.toLowerCase()
    .replace(/\b(international|motorsports?|raceway|speedway|park|circuit|motor speedway|road course|racetrack|grand prix|motor park|proving ground|motocross|track|lions|club|motor|racing|motorplex|complex|facility|center|centre)\b/g,' ')
    .replace(/[^a-z0-9 ]/g,' ')
    .replace(/\s+/g,' ')
    .trim();
}

/* Track-type ↔ org-discipline compatibility. This is how we stop HPDE/TT
   events from appearing at motocross tracks (the "Canaan Lions" bug).
   If the event's org has a known discipline that can't physically happen
   at this track type, the event is filtered out even if names tokenize
   similarly. `both` and legacy moto/auto map to road/oval tracks. */
var TRACK_ORG_COMPAT = {
  'road':       {'auto':1,'moto':1,'both':1,'mx':1,'offroad':1,'drift':1,'supermoto':1}, // drift at Road Atlanta, Laguna, VIR, Stafford; supermoto on infield sections
  'oval':       {'auto':1,'moto':1,'both':1,'offroad':1,'drift':1},        // Irwindale, Texas MS, LVMS host drift
  'kart':       {'kart':1,'auto':1,'drift':1,'supermoto':1},               // Driftindy at kart tracks; some kart schools run drift; supermoto runs on kart layouts
  'mx':         {'mx':1,'moto':1},
  'drag':       {'drag':1,'auto':1,'moto':1,'both':1,'offroad':1,'drift':1},
  'offroad':    {'offroad':1,'mx':1,'moto':1,'both':1,'auto':1},
  'supermoto':  {'supermoto':1,'moto':1,'mx':1,'kart':1},                   // dedicated supermoto tracks; allow moto/mx/kart fallbacks
  'publicroad': {}
};
function _compatible(trackType, orgDiscipline){
  if(!trackType)return true;                    // unknown track type — allow
  // Venue-scraped events come from the track's own website, so they're
  // inherently about that venue. Wildcard-compatible regardless of track type.
  if(orgDiscipline==='venue')return true;
  if(!orgDiscipline)return trackType==='road';  // unknown org — default to road (legacy data)
  var allowed=TRACK_ORG_COMPAT[trackType];
  if(!allowed)return true;                      // unrecognized track type — allow
  return allowed[orgDiscipline]===1;
}
/* Title-level guard: even within a compatible track type, filter out events
   whose TITLE obviously belongs to a different discipline. Belt-and-suspenders
   for scraper misses where the org is wrong or untagged. */
// MX-track title guard — kill these specific auto-world titles from landing on
// dirt bike venues. 'track day' was removed from this list because MX tracks
// legitimately run dirt-bike track days.
var _MX_TITLE = /\b(hpde|time trial|tt\b|road race|wheel.?to.?wheel|lemons|24 hours of|chump|endurance road)\b/i;
// Road/oval track guard — only block the strict dirt-bike-only formats.
// GNCC, hare scramble, enduro were REMOVED: GNCC runs Watkins Glen, enduros
// happen at road facilities with off-road sections. Let those through.
var _ROAD_TITLE = /\b(motocross|arenacross|supercross|mx\b)\b/i;
function _titleCompatible(trackType, title){
  if(!title)return true;
  if(trackType==='mx'   && _MX_TITLE.test(title))   return false;
  if(trackType==='road' && _ROAD_TITLE.test(title)) return false;
  if(trackType==='oval' && _ROAD_TITLE.test(title)) return false;
  return true;
}
function _orgDisciplineFor(org_id){
  if(!org_id)return null;
  var orgs=(window.GARA_EVENTS&&window.GARA_EVENTS.orgs)||[];
  for(var i=0;i<orgs.length;i++)if(orgs[i].id===org_id)return orgs[i].discipline||null;
  return null;
}

function _eventsForFacility(fac){
  if(!window.GARA_EVENTS||!window.GARA_EVENTS.events)return [];
  var facNorm=_normalizeTrack(fac.n);
  if(!facNorm)return [];
  var facTokens=facNorm.split(' ').filter(function(w){return w.length>2;});
  if(facTokens.length===0)return [];
  var today=new Date().toISOString().slice(0,10);
  var hits=[];
  window.GARA_EVENTS.events.forEach(function(e){
    // Use date_end so in-progress multi-day events remain visible
    var endD=(e.date_end||e.date_start||'').slice(0,10);
    if(endD && endD < today) return;  // past
    // Track-type vs org-discipline compatibility gate (fixes HPDE-at-MX bug).
    // Prefer event-level discipline (set by classify_venue_disciplines for
    // venue events whose title makes the type unambiguous) so a "Supermoto
    // Series" event at a venue resolves to supermoto, not venue.
    var disc=e.discipline||_orgDisciplineFor(e.org_id);
    if(!_compatible(fac.tp,disc))return;
    // Title-level guard for obvious mismatches
    if(!_titleCompatible(fac.tp,e.title))return;
    // Some org parsers (WMRRA, PCA, IHRA, AMA D37, AMA D17, evolvegt, ...)
    // populate the track name in `title` instead of `track_name`. Fall back
    // to title so those events can still match a facility. The token-share
    // gate below rejects events whose title is a real title (not a venue
    // name), so this is safe.
    var trackSrc = e.track_name || e.title || '';
    var rawNorm=_normalizeTrack(trackSrc);
    if(!rawNorm)return;
    var rawTokens=rawNorm.split(' ').filter(function(w){return w.length>2;});
    var shared=facTokens.filter(function(t){return rawTokens.indexOf(t)>=0;});
    if(shared.length===0)return;
    // If state is set on both, must match
    if(e.state && fac.s && e.state.toUpperCase() !== fac.s.toUpperCase())return;

    // STRICT raw-name guard (added 2026-05-19 after East Carolina Motor
    // Speedway events were collapsing onto Carolina Speedway because both
    // strip down to "carolina"). When tokens-after-normalization match
    // only weakly, fall back to a raw-name substring check.
    var facNameLow=(fac.n||'').toLowerCase().trim();
    var evNameLow=(trackSrc||'').toLowerCase().trim();

    // Generic words that don't count as identity tokens — these collapse
    // unrelated tracks if treated as shared (e.g. "carolina speedway" vs
    // "east carolina motor speedway" both share "carolina" + "speedway"
    // but are different facilities).
    var GENERIC_WORDS={
      speedway:1, raceway:1, park:1, motorsports:1, motorsport:1,
      motor:1, international:1, circuit:1, complex:1, course:1,
      racetrack:1, racing:1, motorplex:1, center:1, centre:1,
      facility:1, club:1, lions:1, drag:1, kart:1, oval:1, road:1,
      track:1, the:1, of:1
    };
    function specificTokens(s){
      return s.split(/\s+/).filter(function(w){
        return w.length > 2 && !GENERIC_WORDS[w];
      });
    }
    var facSpecific=specificTokens(facNameLow);
    var evSpecific=specificTokens(evNameLow);
    // Specific-token overlap (excluding generic words)
    var specificShared=facSpecific.filter(function(t){return evSpecific.indexOf(t)>=0;});

    var shareRatio=shared.length/Math.max(facTokens.length,1);
    if(shareRatio < 0.5 && shared.length < 2) return;  // weak match — drop

    // Strict identity check: if facility is multi-specific-token and event
    // is multi-specific-token, require ≥2 SPECIFIC shared tokens
    // (generics don't count). Catches Carolina Speedway vs East Carolina
    // Motor Speedway (specificShared = ['carolina'] only → drop).
    if(facSpecific.length >= 2 && evSpecific.length >= 2){
      if(specificShared.length < 2) return;
    }
    // For single-specific-token facilities (rare — e.g. "Carolina Speedway"
    // where 'speedway' is generic), require the FULL facility raw name
    // (lowercased, generics removed) to appear in the event's raw track_name.
    else if(facSpecific.length === 1){
      // The event must contain the same single specific token AND
      // not contain another DIFFERENT specific track-discriminator word
      // (e.g. "east", "north", "south", "old", "new") that would distinguish.
      var DISCRIMINATORS={east:1,west:1,north:1,south:1,old:1,'new':1,upper:1,lower:1,big:1,little:1,grand:1};
      var evHasDiscriminator=false;
      for(var idx=0; idx<evSpecific.length; idx++){
        if(DISCRIMINATORS[evSpecific[idx]] && facSpecific.indexOf(evSpecific[idx])<0){
          evHasDiscriminator=true; break;
        }
      }
      if(evHasDiscriminator) return;  // different track with prefix discriminator
    }

    // Pre-existing weaker guard kept for compatibility
    if(shared.length < 2){
      var facRawTokens=facNameLow.split(/\s+/).filter(function(w){return w.length>2;});
      var evRawTokens=evNameLow.split(/\s+/).filter(function(w){return w.length>2;});
      if(facRawTokens.length > 1 && evRawTokens.length > 1){
        var rawShared=facRawTokens.filter(function(t){return evRawTokens.indexOf(t)>=0;});
        if(rawShared.length < 2) return;
      }
    }
    // Price filter — drop events whose price doesn't match the active bracket
    if(priceF!=='all' && !_priceMatches(e.price_usd))return;
    hits.push(e);
  });
  // Sort ascending by date. Return the FULL upcoming list — the per-panel
  // 8-event cap is applied later in renderEvents AFTER the discipline filter
  // runs, otherwise a 30-event facility whose first 8 chronological events
  // are all auto would show 0 events in Moto mode even when moto events
  // exist on dates 9+.
  hits.sort(function(a,b){return (a.date_start||'').localeCompare(b.date_start||'');});
  return hits;
}
function _formatDate(iso){
  if(!iso)return '';
  var m=/^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if(!m)return iso;
  var months=['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
  var yr=parseInt(m[1],10);
  var thisYr=new Date().getFullYear();
  var base=months[parseInt(m[2],10)-1]+' '+parseInt(m[3],10);
  // Append a 2-digit year suffix when the event isn't in the current calendar year
  // — prevents a 2027 date from reading as "Jan 17" and looking past.
  return yr===thisYr ? base : base+" '"+String(yr).slice(-2);
}
// Build a 7-column month grid for the event's start-month, highlighting every
// day in [date_start, date_end]. Header reads "Pick a day to sign up"; clicking
// any highlighted day opens the event signup URL.
var MONTH_NAMES=['January','February','March','April','May','June','July','August','September','October','November','December'];
var DOW=['S','M','T','W','T','F','S'];
function _parseISO(iso){
  var m=/^(\d{4})-(\d{2})-(\d{2})/.exec(iso||'');
  if(!m)return null;
  return new Date(parseInt(m[1]),parseInt(m[2])-1,parseInt(m[3]));
}
function _ymd(d){return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');}
function renderCalendarFor(ev){
  var cal=document.getElementById('ev-cal');
  if(!cal)return;
  var ds=_parseISO(ev.date_start);
  if(!ds){cal.classList.remove('show');return;}
  var de=_parseISO(ev.date_end)||ds;
  var y=ds.getFullYear(),m=ds.getMonth();
  var firstDow=new Date(y,m,1).getDay();
  var daysInMonth=new Date(y,m+1,0).getDate();
  var today=new Date();today.setHours(0,0,0,0);
  var cells='';
  // DOW header row
  DOW.forEach(function(d){cells+='<div class="evc-dow">'+d+'</div>';});
  // Leading blanks
  for(var i=0;i<firstDow;i++)cells+='<div class="evc-day empty"></div>';
  // Day cells
  for(var d=1;d<=daysInMonth;d++){
    var cur=new Date(y,m,d);
    var hl=(cur>=new Date(ds.getFullYear(),ds.getMonth(),ds.getDate())&&cur<=new Date(de.getFullYear(),de.getMonth(),de.getDate()));
    var isToday=(cur.getTime()===today.getTime());
    var cls='evc-day'+(hl?' hl':'')+(isToday?' today':'');
    cells+='<div class="'+cls+'" data-d="'+_ymd(cur)+'">'+d+'</div>';
  }
  cal.innerHTML=
    '<button type="button" class="evc-close" aria-label="Close calendar">&times;</button>'+
    '<div class="evc-head">Pick a day to sign up</div>'+
    '<div class="evc-month">'+MONTH_NAMES[m]+' '+y+'</div>'+
    '<div class="evc-grid">'+cells+'</div>'+
    '<div class="evc-foot">'+(ev.org_name||'')+(ev.title?' &middot; '+ev.title:'')+'</div>';
  // Close button (visible on touch and desktop alike)
  var closeBtn = cal.querySelector('.evc-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function(e){
      e.stopPropagation();
      cal.classList.remove('show');
    });
  }
  // Highlighted day click → navigate to the signup URL.
  // Priority (no calendar/aggregator pages):
  //   1. ev.url               — per-event deep link (best — exact signup page)
  //   2. ev.signup_url        — backfilled in push_to_shopify; could be a
  //                              calendar or website
  //   3. ev.org_website       — guaranteed-safe org homepage fallback
  // Rule: if ev.url is absent and signup_url smells like a calendar
  // ('/events', '/calendar', '/schedule' in path), prefer org_website so
  // the rider doesn't bounce to an aggregator page that isn't this event.
  function _looksLikeCalendar(u){
    if(!u) return false;
    var lo = u.toLowerCase();
    return /\/(events?|calendar|schedule|race-?series|schedules?)(?:\/|\?|$)/.test(lo);
  }
  var perEvent = ev.url || '';
  var signup   = ev.signup_url || '';
  var website  = ev.org_website || '';
  var target = perEvent
            || (signup && (!_looksLikeCalendar(signup) ? signup : (website || signup)))
            || website
            || '';
  if(target){
    cal.querySelectorAll('.evc-day.hl').forEach(function(el){
      el.style.cursor='pointer';
      el.title='Click to sign up';
      el.addEventListener('click',function(){window.open(target,'_blank','noopener');});
    });
  }
  // Footer becomes a small "Visit org" link too so riders have a path even
  // when no day is in the current month view.
  var foot = cal.querySelector('.evc-foot');
  if(foot && (website || target)){
    var orgUrl = website || target;
    foot.innerHTML = (ev.org_name||'') + (ev.title?' &middot; '+ev.title:'')
                    + ' &middot; <a href="'+orgUrl+'" target="_blank" rel="noopener" style="color:var(--g);text-decoration:underline">visit org</a>';
  }
}
function positionCalendarNextTo(rowEl){
  var cal=document.getElementById('ev-cal');
  var panel=document.getElementById('spnl');
  if(!cal||!panel||!rowEl)return;
  var pRect=panel.getBoundingClientRect();
  var rRect=rowEl.getBoundingClientRect();
  var calW=cal.offsetWidth || 232;
  var calH=cal.offsetHeight || 280;
  // Mobile: the panel is full-width, so "right of panel" is off-screen. Anchor
  // the calendar centered horizontally and just above the tapped row instead.
  var isMobile = window.innerWidth <= 768;
  if(isMobile){
    var left = Math.max(12, Math.min(window.innerWidth - calW - 12,
                                     rRect.left + rRect.width/2 - calW/2));
    cal.style.left = left + 'px';
    var top = rRect.top - calH - 12;
    if(top < 12) top = Math.min(window.innerHeight - calH - 12, rRect.bottom + 12);
    if(top < 12) top = 12;
    cal.style.top = top + 'px';
    return;
  }
  // Desktop: slide out to the right of the panel, vertically anchored to row.
  // Clamp horizontally too so the calendar doesn't slide under the right
  // sidebar or off the viewport at narrower widths.
  var maxLeft = window.innerWidth - calW - 12;
  cal.style.left = Math.min(pRect.right + 10, maxLeft) + 'px';
  var topDsk=rRect.top-20;
  var maxTop=window.innerHeight-calH-12;
  if(topDsk>maxTop)topDsk=maxTop;
  if(topDsk<10)topDsk=10;
  cal.style.top=topDsk+'px';
}

var _evCalHideTimer=null;
function _showCal(ev,rowEl){
  clearTimeout(_evCalHideTimer);
  renderCalendarFor(ev);
  var cal=document.getElementById('ev-cal');
  // Position once before revealing (transform transition animates the slide).
  positionCalendarNextTo(rowEl);
  cal.classList.add('show');
  // Re-position on next frame in case rendering changed its height.
  requestAnimationFrame(function(){positionCalendarNextTo(rowEl);});
}
function _hideCalSoon(){
  clearTimeout(_evCalHideTimer);
  _evCalHideTimer=setTimeout(function(){
    var cal=document.getElementById('ev-cal');
    if(cal)cal.classList.remove('show');
  },180);
}
// Keep calendar open while user moves cursor onto it, AND give touch users
// a way to close it (tap outside or press Escape).
(function bindCalHover(){
  var cal=document.getElementById('ev-cal');
  if(!cal)return;
  cal.addEventListener('mouseenter',function(){clearTimeout(_evCalHideTimer);});
  cal.addEventListener('mouseleave',_hideCalSoon);
  // Tap anywhere outside the calendar (and outside the source event row)
  // closes it. Only fires when calendar is actually visible.
  document.addEventListener('pointerdown', function(e){
    if(!cal.classList.contains('show')) return;
    if(cal.contains(e.target)) return;
    if(e.target.closest('.ev-row')) return;   // hovering another row will re-show
    cal.classList.remove('show');
  }, true);
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && cal.classList.contains('show')){
      cal.classList.remove('show');
    }
  });
})();

function renderEvents(facility){
  var host=document.getElementById('sp-events');
  if(!host)return;
  var events=_eventsForFacility(facility);
  if(!events.length){host.style.display='none';host.innerHTML='';return;}
  host.style.display='block';
  // Build an id -> discipline index once, reuse per row.
  var _orgDisc={};var _orgMeta=(window.GARA_EVENTS&&window.GARA_EVENTS.orgs)||[];
  _orgMeta.forEach(function(o){_orgDisc[o.id]=(o.discipline||'').toLowerCase();});
  // For v-* venue-scraped events ("Precision Track Day at VIR"), the source
  // org_id is the venue (v-vir) but the REAL org is named in the title.
  // Build a longest-first lookup of real-org names → discipline so we can
  // re-attribute. Longest-first matters because "Apex" is a substring of
  // longer names; we want the most specific match.
  // Build the name → discipline lookup for v-* venue retag. Index both the
  // org's short name AND its full marketing name (e.g. STT → "Sportbike
  // Track Time", YCRS → "Yamaha Champions Riding School"), because venue
  // calendars almost always use the marketing name in event titles.
  // 6-char minimum on derived "short" names to avoid false-positive
  // substring matches (e.g. "Apex" matching Road America's "APEX ONE",
  // "Edge" matching some random "edge" word in an unrelated event).
  var _nameDiscMap=[];
  _orgMeta.forEach(function(o){
    if(o.id && o.id.charAt(0)==='v') return;        // skip venue placeholders
    var d=(o.discipline||'').toLowerCase();
    if(!d || d==='venue') return;
    var added={};
    function pushName(nm){
      if(!nm) return;
      var key=nm.toLowerCase().trim();
      if(!key || added[key]) return;
      if(key.length < 6) return;                    // too short → substring false-positive risk
      added[key]=1;
      _nameDiscMap.push({n:key, d:d});
    }
    pushName(o.name);
    pushName(o.full_name);
    pushName(o.short_name);
    // Stripped variant of the long-form name, only if it still parses cleanly.
    var src=(o.full_name||o.name||'').trim();
    var stripped=src.replace(/\bracing\b|\bmotorcycle\b|\bclub\b|\btrack\s*days?\b|\bsports?\b/gi,'').trim();
    if(stripped && stripped!==src) pushName(stripped);
  });
  _nameDiscMap.sort(function(a,b){return b.n.length-a.n.length;});
  function _venueEventDisc(ev){
    var t=((ev.title||'')+' '+(ev.org_name||'')).toLowerCase();
    for(var i=0;i<_nameDiscMap.length;i++){
      var entry=_nameDiscMap[i];
      // require a word boundary on at least one side to avoid e.g. "n2" matching "n2o"
      var idx=t.indexOf(entry.n);
      if(idx<0) continue;
      var pre=idx===0?' ':t.charAt(idx-1);
      var post=idx+entry.n.length>=t.length?' ':t.charAt(idx+entry.n.length);
      if(/[a-z0-9]/.test(pre)) continue;
      if(/[a-z0-9]/.test(post)) continue;
      return entry.d;
    }
    return null;
  }
  var DISC_LABELS={moto:'Moto',auto:'Auto',mx:'MX',supermoto:'S-Moto',kart:'Kart',drag:'Drag',offroad:'Off-Road',drift:'Drift',oval:'Oval',road:'Road',both:'Both',venue:'Venue'};
  // Event discipline tag — pick the most specific of:
  //   1. Keyword sniff from event title/name (MX / motocross / kart / drag /
  //      offroad / drift / tandem battle) — most accurate because it's per-event.
  //   2. Org's own specialty discipline if it IS a specialty (drift/mx/kart/
  //      drag/offroad). A drift series running at a drag strip is a Drift event,
  //      not a Drag event — the org classification wins here.
  //   3. Facility is *purely* specialty (all configs are mx/kart/drag/offroad,
  //      no road/oval mix) — applies only when org is moto/auto (generic) so we
  //      can infer the sub-specialty from the venue (AHRMA on an MX track = MX).
  //   4. Org's discipline (moto/auto) — final fallback for championship road-racing.
  var facTps=(facility.configs||[]).map(function(c){return c.tp;});
  var SPECIALTY_DISCS={mx:1,kart:1,drag:1,offroad:1,drift:1};
  var SPECIALTY_FAC={mx:1,kart:1,drag:1,offroad:1};
  var facAllSpecialty=facTps.length&&facTps.every(function(tp){return SPECIALTY_FAC[tp];});
  var facSpecialty=facAllSpecialty?facTps.find(function(tp){return SPECIALTY_FAC[tp];}):null;
  function _sniffEventDisc(ev){
    var t=((ev.title||'')+' '+(ev.name||'')+' '+(ev.description||'')).toLowerCase();
    if(/\b(mx|motocross|supercross|arenacross|sx|flat\s*track|observed\s*trials)\b/.test(t))return 'mx';
    if(/\bkart(ing)?\b|\bkart\s*track\b/.test(t))return 'kart';
    if(/\bdrag\s*rac|\bnitro\b|\btop\s*fuel\b|\bnhra\b/.test(t))return 'drag';
    /* Off-road: hare-scramble, desert race, cross-country, baja, dakar.
       Rally is excluded from this branch — it matches both off-road
       motorcycle rally-raid AND on-road auto road-rally (Lemons). Handle
       rally separately below with auto/lemons rejection.
       enduro: only the MX-style enduro (hare-scramble, woods, GNCC variants),
       NOT auto endurance racing. Reject the match if the title also mentions
       imsa/porsche/usac/wec/sportscar/grand prix/sprint/wrl/lemons. */
    if(/\boff[- ]?road|\bdesert\s+(race|classic|showdown|raid)\b|\bdakar\b|\bbaja\b|\bhare\s*scramble|\bcross\s*country\b/.test(t))return 'offroad';
    if(/\brally\b/.test(t) && !/\b(lemons|hell\s*on\s*wheels|land\s*of\s*lincolns|24\s*hours)/i.test(t)) return 'offroad';
    if(/\benduro\b/.test(t) && !/\b(imsa|porsche|usac|wec|sportscar|grand\s*prix|sprint|wrl|lemons|enduro\s*cup\b)/i.test(t)) return 'offroad';
    if(/\bdrift(ing)?\b|\btandem\s*battle\b|\bformula\s*d(rift)?\b/.test(t))return 'drift';
    return null;
  }
  // Resolve each event's effective discipline once, then filter by the
  // global discF before rendering. moto/auto/drift modes hide events that
  // are exclusively the other side — so a 'Moto' filter on a multi-discipline
  // venue (Road Atlanta, NJMP, etc.) shows only motorcycle events, not the
  // SCCA / NASA-auto / Champcar dates.
  var EVENT_DISC_BUCKETS={
    /* moto bucket includes offroad because desert-race series (SCORE Baja,
       BITD, AMA Hare Scramble, GNCC) run both 4-wheel and 2-wheel classes —
       a moto rider would expect to see them when browsing in Moto mode. */
    moto:{moto:1, mx:1, offroad:1, supermoto:1, both:1},
    auto:{auto:1, kart:1, drag:1, offroad:1, both:1},
    drift:{drift:1},
    supermoto:{supermoto:1},
    mx:{mx:1},
    kart:{kart:1},
    drag:{drag:1},
    offroad:{offroad:1},
    oval:{auto:1, moto:1, both:1},   // ovals serve both — let any event through
    road:{auto:1, moto:1, both:1, supermoto:1, drift:1},
  };
  var resolved=events.map(function(e,i){
    var orgD=_orgDisc[e.org_id]||'';
    var orgSpecialty=SPECIALTY_DISCS[orgD]?orgD:null;
    // For v-* venue-scraped events, prefer the real org named in the title
    // over the venue placeholder. So "Precision Track Day (N)" at VIR (which
    // scrapes with org_id=v-vir, orgD=venue) gets re-tagged from the title.
    var venueRetag=(orgD==='venue')?_venueEventDisc(e):null;
    var d=venueRetag||_sniffEventDisc(e)||orgSpecialty||facSpecialty||orgD||'';
    return {ev:e, idx:i, d:d};
  });
  var filtered=resolved;
  if(EVENT_DISC_BUCKETS[discF]){
    var bucket=EVENT_DISC_BUCKETS[discF];
    filtered=resolved.filter(function(r){
      if(!r.d) return true;          // unknown discipline → keep (don't false-negative)
      if(r.d==='venue') return true; // venue/info events show under any filter
      return !!bucket[r.d];
    });
  }
  // Cap to 8 rows AFTER discipline filtering so we don't waste the panel on
  // events the current mode hides. Track the pre-cap total for the header.
  var filteredTotal = filtered.length;
  if (filtered.length > 8) filtered = filtered.slice(0, 8);
  if(!filtered.length){host.style.display='none';host.innerHTML='';return;}
  var rows=filtered.map(function(r){
    var e=r.ev, i=r.idx, d=r.d;
    var d1=_formatDate(e.date_start);
    // Multi-day cross-month: "MAY 30 — JUN 2" (not "MAY 30-2") when months differ.
    var d2='';
    if(e.date_end && e.date_end!==e.date_start){
      var f2=_formatDate(e.date_end);          // e.g. "JUN 2"
      var f2_month=f2.split(' ')[0];
      var d1_month=d1.split(' ')[0];
      d2 = (f2_month===d1_month) ? ('-'+f2.split(' ')[1]) : (' — '+f2);
    }
    var date=d1+d2;
    var discBadge=d&&DISC_LABELS[d]?'<span class="ev-disc" data-d="'+d+'">'+DISC_LABELS[d]+'</span>':'';
    var priceBadge='';
    if(typeof e.price_usd==='number' && e.price_usd>0){
      priceBadge='<span class="ev-price" title="Competitor entry fee">$'+Math.round(e.price_usd)+'</span>';
    }
    var hasUrl = !!(e.url || e.signup_url);
    var registerHint = hasUrl ? '<span class="ev-go" aria-label="Open registration">↗</span>' : '';
    return '<div class="ev-row'+(hasUrl?' has-url':'')+'" data-ei="'+i+'">'+
      '<span class="ev-date">'+date+'</span>'+
      '<span class="ev-wx" data-wx="'+i+'"></span>'+
      discBadge+
      '<span class="ev-org">'+(e.org_name||'')+'</span>'+
      '<span class="ev-title">'+(e.title||'Event')+'</span>'+
      priceBadge+
      registerHint+
      '</div>';
  }).join('');
  var totalAll = events.length;
  var totalFiltered = filteredTotal;
  var discLabel = discF==='moto'?'moto':discF==='auto'?'auto':discF==='drift'?'drift':null;
  var countLabel;
  if (discLabel && totalFiltered !== totalAll) {
    countLabel = 'Upcoming ('+filtered.length+' shown · '+totalFiltered+' '+discLabel+' · '+totalAll+' total)';
  } else if (totalFiltered > filtered.length) {
    countLabel = 'Upcoming ('+filtered.length+' shown · '+totalFiltered+' total)';
  } else {
    countLabel = 'Upcoming ('+totalFiltered+')';
  }
  host.innerHTML='<div class="ev-head">'+countLabel+'</div>'+rows;
  // Bind calendar trigger on each row. Desktop: hover. Touch/coarse-pointer:
  // tap once to peek the calendar (second tap on the row's URL still fires below).
  host.querySelectorAll('.ev-row').forEach(function(row){
    var ev=events[parseInt(row.dataset.ei)];
    // Desktop: hover still previews the calendar
    row.addEventListener('mouseenter',function(){_showCal(ev,row);});
    row.addEventListener('mouseleave',_hideCalSoon);
    // Click ALWAYS opens the calendar — old behavior navigated straight to a
    // signup URL but for many events that URL was the org's full events
    // calendar (not the specific event), which surprised riders. New flow:
    //   row click  -> open mini-calendar widget
    //   day click  -> navigate to that event's signup (or org website
    //                  if we don't have a per-event signup)
    // Mobile gets the same path: tap a row -> calendar appears -> tap a
    // highlighted day -> open the link. No hover required.
    row.addEventListener('click',function(e){
      if(e.target.closest('#ev-cal'))return;
      _showCal(ev,row);
    });
  });
  // Kick off weather lookup for this facility's upcoming events
  applyWeatherIcons(facility,events,host);
}

// Search — matches both facility names and individual config names.
// Picking a config result opens its parent facility with that config active.
function initSearch(){
  var inp=document.getElementById('search');
  var sug=document.getElementById('suggest');
  // Accent + punctuation strip so "thunder hill" matches "Thunderhill" and
  // "mont tremblant" matches "Mont-Tremblant". The token-set is rebuilt on
  // every keystroke (small data; 491 facilities) — no perf concern.
  function norm(s){
    return (s||'').toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g,'')      // strip diacritics
      .replace(/[^a-z0-9]+/g,' ').trim();                    // collapse punct
  }
  // Multi-token AND match: every token in the query must appear somewhere in
  // the haystack. Lets "thunder park" find "Thunder Hill Park" and "mid ohio"
  // find "Mid-Ohio Sports Car Course".
  function matches(haystack, tokens){
    var h = norm(haystack);
    return tokens.every(function(t){ return h.indexOf(t) >= 0; });
  }
  // Keyboard nav helpers
  var _hits = [];
  var _highlight = -1;
  function setHighlight(i){
    var items = sug.querySelectorAll('.si');
    items.forEach(function(el,k){ el.classList.toggle('hl', k===i); });
    _highlight = i;
    inp.setAttribute('aria-activedescendant', i>=0 ? 'si-'+i : '');
    if(i>=0 && items[i]) items[i].scrollIntoView({block:'nearest'});
  }
  function selectHit(i){
    var h = _hits[i]; if(!h) return;
    var fac=FACILITIES[h.facIdx];
    // Mark the override BEFORE selTk so its sel!==t reset path respects it.
    fac._cfgIdxOverride=h.cfgIdx;
    fac._activeConfig=h.cfgIdx;
    var c=fac.configs[h.cfgIdx];
    fac.l=c.l;fac.tu=c.tu;fac.el=c.el;fac.sg=c.sg;fac.tp=c.tp;fac.o=c.o;
    selTk(fac);
    inp.value='';sug.style.display='none';
    _hits=[]; _highlight=-1;
  }
  inp.setAttribute('role','combobox');
  inp.setAttribute('aria-controls','suggest');
  inp.setAttribute('aria-autocomplete','list');
  inp.setAttribute('aria-expanded','false');
  sug.setAttribute('role','listbox');

  inp.addEventListener('input',function(){
    var raw=this.value.trim();
    if(raw.length<2){sug.style.display='none';inp.setAttribute('aria-expanded','false');_hits=[];return;}
    var tokens = norm(raw).split(' ').filter(function(t){return t.length>0;});
    _hits=[];
    for(var i=0;i<FACILITIES.length && _hits.length<30;i++){
      var f=FACILITIES[i];
      if(matches(f.n, tokens)){
        _hits.push({name:f.n,sub:f.s+(f.configs.length>1?' · '+f.configs.length+' configs':''),facIdx:i,cfgIdx:0});
      }
      for(var j=0;j<f.configs.length && _hits.length<30;j++){
        var c=f.configs[j];
        if(c.n===f.n)continue;
        if(matches(c.n, tokens) || matches(c._label||'', tokens)){
          _hits.push({name:c.n,sub:f.n+' · '+f.s,facIdx:i,cfgIdx:j});
        }
      }
    }
    if(!_hits.length){
      sug.innerHTML='<div class="si si-empty" aria-disabled="true" role="option">No tracks match — try fewer words</div>';
      sug.style.display='block';inp.setAttribute('aria-expanded','true');
      return;
    }
    sug.innerHTML=_hits.slice(0,15).map(function(h,k){
      return '<div class="si" role="option" id="si-'+k+'" data-k="'+k+'">'+h.name+'<span class="st">'+h.sub+'</span></div>';
    }).join('');
    sug.style.display='block';inp.setAttribute('aria-expanded','true');
    _highlight=-1;
    sug.querySelectorAll('.si').forEach(function(el){
      el.addEventListener('click',function(){ selectHit(parseInt(this.dataset.k)); });
      el.addEventListener('mouseenter',function(){ setHighlight(parseInt(this.dataset.k)); });
    });
  });
  inp.addEventListener('blur',function(){setTimeout(function(){sug.style.display='none';inp.setAttribute('aria-expanded','false');},200);});
  inp.addEventListener('keydown',function(e){
    var n = sug.querySelectorAll('.si:not(.si-empty)').length;
    if(e.key==='Escape'){ sug.style.display='none'; inp.setAttribute('aria-expanded','false'); return; }
    if(e.key==='ArrowDown' && n>0){ e.preventDefault(); setHighlight((_highlight+1) % n); return; }
    if(e.key==='ArrowUp' && n>0){ e.preventDefault(); setHighlight(_highlight<=0 ? n-1 : _highlight-1); return; }
    if(e.key==='Enter' && _highlight>=0){ e.preventDefault(); selectHit(_highlight); return; }
    if(e.key==='Enter' && n>0){ e.preventDefault(); selectHit(0); return; }   // first hit on enter
  });
}

// Active-filter state + mobile chip sync (function kept name updTypes so callers
// don't churn; despite the name it no longer touches TYPES — it refreshes all
// filter button states + mobile chip labels).
function updTypes(){
  document.querySelectorAll('.tbtn[data-cat]').forEach(function(b){b.classList.toggle('ac',b.dataset.cat===catF);});
  document.querySelectorAll('.tbtn[data-disc]').forEach(function(b){b.classList.toggle('ac',b.dataset.disc===discF);});
  document.querySelectorAll('.tbtn[data-price]').forEach(function(b){b.classList.toggle('ac',b.dataset.price===priceF);});
  var anyActive=(catF!=='all'||stateF!=='All'||orgF!=='All'||discF!=='all'||priceF!=='all');
  var rbtn=document.getElementById('rbtn');
  if(rbtn)rbtn.style.display=anyActive?'block':'none';
  var fb=document.getElementById('filter-btn');
  if(fb)fb.classList.toggle('has-active',anyActive);
  var fab=document.getElementById('filter-fab');
  if(fab)fab.classList.toggle('has-active',anyActive);
  updMobileChips(anyActive);

  // Render the active-filter chip row at the top of the drawer. Each chip
  // shows the filter name + value with an x to clear that one dimension.
  var afilt=document.getElementById('afilt');
  if(afilt){
    var chips=[];
    function makeChip(key, label, clearFn){
      chips.push({k:key, label:label, clear:clearFn});
    }
    function _labelFor(arr, id){
      var hit = arr && arr.find && arr.find(function(x){return x.id===id;});
      return hit ? hit.label : id;
    }
    var _orgs = (window.GARA_EVENTS && window.GARA_EVENTS.orgs) || [];
    var _orgMatch = _orgs.find(function(o){return o.id===orgF;});
    if(discF!=='all')  makeChip('disc','Discipline · ' + _labelFor(DISCS, discF),  function(){discF='all';});
    if(catF!=='all')   makeChip('cat', 'Category · '   + _labelFor(CATS,  catF),   function(){catF='all';});
    if(stateF!=='All') makeChip('state','State · '+stateF, function(){stateF='All';});
    if(priceF!=='all') makeChip('price','Price · '    + _labelFor(PRICES,priceF),  function(){priceF='all';});
    if(orgF!=='All')   makeChip('org', 'Org · ' + (_orgMatch ? (_orgMatch.name||_orgMatch.full_name||orgF) : orgF), function(){orgF='All';});
    if(chips.length === 0){
      afilt.innerHTML='';
    } else {
      afilt.innerHTML = chips.map(function(c,i){
        return '<button type="button" class="achip" data-i="'+i+'" aria-label="Remove filter: '+c.label+'">'+
               '<span class="ach-label">'+c.label+'</span>'+
               '<span class="ach-x" aria-hidden="true">×</span></button>';
      }).join('');
      afilt.querySelectorAll('.achip').forEach(function(el){
        el.addEventListener('click', function(){
          var c = chips[parseInt(this.dataset.i)];
          if(!c) return;
          c.clear();
          updTypes();
          buildStates();
          buildOrgs();
          initCats();
          initDiscs();
          initPrices();
          refresh();
        });
      });
    }
  }
}

// Mobile chip row — shows active filter values as chips. Tapping any chip
// opens the existing filter drawer. Active filters get highlighted.
function updMobileChips(anyActive){
  var catLabel =(CATS.find ?CATS.find (function(c){return c.id===catF ;}):null);
  catLabel =catLabel ?catLabel.label :(catF==='all'?'All':catF);
  var discLabel=(DISCS.find?DISCS.find(function(d){return d.id===discF;}):null);
  discLabel=discLabel?discLabel.label:(discF==='all'?'All':discF);
  var orgLabel ='All';
  if(orgF!=='All'){
    var orgs=(window.GARA_EVENTS&&window.GARA_EVENTS.orgs)||[];
    var match=orgs.find(function(o){return o.id===orgF;});
    orgLabel=match?(match.name||match.full_name||orgF):orgF;
  }
  var priceLabel=(PRICES.find?PRICES.find(function(p){return p.id===priceF;}):null);
  priceLabel=priceLabel?priceLabel.label:(priceF==='all'?'Any':priceF);
  var map={cat:catLabel,state:stateF,disc:discLabel,price:priceLabel,org:orgLabel};
  ['cat','state','disc','price','org'].forEach(function(k){
    var el=document.getElementById('mfc-'+k);
    if(el){
      el.textContent=map[k].length>14?map[k].slice(0,13)+'…':map[k];
      var chip=el.closest('.mfc');
      if(chip){
        var isDefault=(map[k]==='All'||map[k]==='ALL');
        chip.classList.toggle('active',!isDefault);
      }
    }
  });
  var reset=document.getElementById('mfc-reset');
  if(reset)reset.style.display=anyActive?'inline-flex':'none';
}

// Category buttons — render into every .cat-btns host (sidebar + mobile sheet).
function initCats(){
  var wraps=document.querySelectorAll('.cat-btns');
  wraps.forEach(function(wrap){
    wrap.innerHTML='';
    CATS.forEach(function(c){
      var b=document.createElement('button');b.className='tbtn'+(catF===c.id?' ac':'');
      b.textContent=c.label;b.dataset.cat=c.id;
      b.addEventListener('click',function(){catF=c.id;updTypes();buildOrgs();refresh();});
      wrap.appendChild(b);
    });
  });
}

// Mobile bottom sheet — #spnl collapses to a peek bar, tap to expand,
// × to close entirely. Desktop ignores all this (matchMedia gate).
var _mq = window.matchMedia ? window.matchMedia('(max-width: 768px)') : {matches:false};
function isMobileBreakpoint(){return _mq.matches;}

// Mobile filter chips — tap any chip opens the filter drawer.
// Reset chip clears all filters in one tap.
function initMobileFilterChips(){
  var row=document.getElementById('mfilt');
  if(!row)return;
  var btn=document.getElementById('filter-btn');
  row.addEventListener('click',function(e){
    var chip=e.target.closest('.mfc');
    if(!chip)return;
    if(chip.id==='mfc-reset'){
      if(typeof resetF==='function')resetF();
      return;
    }
    // Any other chip just opens the drawer (which holds all filters).
    if(btn)btn.click();
  });
}

function initMobileBottomSheet(){
  var pnl   = document.getElementById('spnl');
  var peek  = document.getElementById('sp-peek');
  var close = document.getElementById('sp-close');
  if(!pnl||!peek)return;

  // Tap the peek header (name + hint) to toggle expanded state on mobile.
  peek.addEventListener('click',function(e){
    if(!isMobileBreakpoint())return;
    // Don't toggle if user tapped the close button bleeding into the peek.
    if(e.target.closest('#sp-close'))return;
    pnl.classList.toggle('expanded');
  });

  // Close button: clear selection entirely.
  if(close){
    close.addEventListener('click',function(e){
      e.stopPropagation();
      pnl.classList.remove('vis');
      pnl.classList.remove('expanded');
      // Also drop .ac state on any selected carousel card / marker.
      document.querySelectorAll('.tc.ac').forEach(function(c){c.classList.remove('ac');});
    });
  }

  // Swipe-down on the panel header (top 50px) closes the card entirely.
  var touchY0=null;
  pnl.addEventListener('touchstart',function(e){
    if(!isMobileBreakpoint())return;
    var rect=pnl.getBoundingClientRect();
    var yLocal=e.touches[0].clientY-rect.top;
    touchY0 = yLocal<50 ? e.touches[0].clientY : null;
  },{passive:true});
  pnl.addEventListener('touchend',function(e){
    if(touchY0==null)return;
    var dy=(e.changedTouches[0].clientY||touchY0)-touchY0;
    if(dy>40){
      pnl.classList.remove('vis'); pnl.classList.remove('expanded');
      document.querySelectorAll('.tc.ac').forEach(function(c){c.classList.remove('ac');});
    }
    touchY0=null;
  });
}

// Mobile filter sheet — toggle #sb in/out with scrim. Bound to BOTH the
// legacy #filter-btn (kept for any deep links) AND the new gold #filter-fab.
function initMobileFilters(){
  var btn=document.getElementById('filter-btn');
  var fab=document.getElementById('filter-fab');
  var sb=document.getElementById('sb');
  var scrim=document.getElementById('filter-scrim');
  var close=document.querySelector('.sb-close');
  if(!sb||!scrim)return;
  function setExpanded(v){
    if(btn)btn.setAttribute('aria-expanded',v?'true':'false');
    if(fab)fab.setAttribute('aria-expanded',v?'true':'false');
  }
  function open(){ sb.classList.add('open'); scrim.classList.add('show'); document.body.classList.add('filter-open'); setExpanded(true); }
  function shut(){ sb.classList.remove('open'); scrim.classList.remove('show'); document.body.classList.remove('filter-open'); setExpanded(false); }
  function toggle(){ sb.classList.contains('open')?shut():open(); }
  if(btn)btn.addEventListener('click',toggle);
  if(fab)fab.addEventListener('click',toggle);
  scrim.addEventListener('click',shut);
  if(close)close.addEventListener('click',shut);
  // ESC closes
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&sb.classList.contains('open'))shut();});
}

/* ─── Org index + sidebar ───
   Build a map from facility name -> Set of org_ids that run events there.
   Used by gf() to filter when orgF is set, and by buildOrgs() for per-org
   event counts shown beside the name. */
function buildOrgIndex(){
  var idx={};
  if(!window.GARA_EVENTS||!window.GARA_EVENTS.events)return idx;
  window.GARA_EVENTS.events.forEach(function(e){
    if(!e.org_id)return;
    // Some org parsers put the track name in `title` instead of `track_name`
    // (WMRRA, PCA, IHRA, AMA D37, ...). Fall back to title so those orgs'
    // facility-org pairings still land in the index. The token-share gate
    // below rejects non-track-name titles, so this is safe.
    var trackSrc = e.track_name || e.title || '';
    if(!trackSrc) return;
    var disc=e.discipline||_orgDisciplineFor(e.org_id);
    var rawNorm=_normalizeTrack(trackSrc);
    if(!rawNorm)return;
    var rawTokensArr=rawNorm.split(' ').filter(function(w){return w.length>2;});
    var rawTokens=new Set(rawTokensArr);
    FACILITIES.forEach(function(f){
      // Same compatibility + state + token-quality gates as _eventsForFacility.
      if(!_compatible(f.tp,disc))return;
      if(!_titleCompatible(f.tp,e.title))return;
      if(e.state && f.s && e.state.toUpperCase()!==f.s.toUpperCase())return;
      var facTokens=_normalizeTrack(f.n).split(' ').filter(function(w){return w.length>2;});
      if(facTokens.length===0)return;
      var shared=facTokens.filter(function(t){return rawTokens.has(t);});
      if(shared.length===0)return;
      var shareRatio=shared.length/facTokens.length;
      if(shareRatio<0.5 && shared.length<2)return;
      if(!idx[f.n])idx[f.n]=new Set();
      idx[f.n].add(e.org_id);
    });
  });
  window._garaFacOrgs=idx;
  return idx;
}

function buildOrgs(){
  var wrap=document.getElementById('org-list');
  if(!wrap)return;
  var meta=(window.GARA_EVENTS && window.GARA_EVENTS.orgs)||[];
  var idx=window._garaFacOrgs||{};

  // For track-type disciplines (road/oval/kart/mx/drag/offroad), the "discipline"
  // filter describes facility type, not org classification. So we must restrict
  // orgs to those that actually host events at matching-type facilities — not
  // rely on org.discipline (which is too coarse: 'moto' orgs run MX, etc.).
  var allowedOrgIds=null;
  if(_TRACK_TYPE_DISCS[discF]){
    allowedOrgIds=new Set();
    FACILITIES.forEach(function(f){
      if(f.cat==='publicroad')return;
      if(!(f.configs||[]).some(function(c){return c.tp===discF;}))return;
      var set=idx[f.n];
      if(set)set.forEach(function(oid){allowedOrgIds.add(oid);});
    });
  }

  // User-typed text search inside the orgs list (small input above the
  // list). Empty string = no name filter.
  var orgSearchEl=document.getElementById('org-search');
  var orgSearchQ=(orgSearchEl?orgSearchEl.value:'').trim().toLowerCase();

  // Filter orgs by current discipline + category selection. Empty list when a
  // filter kills everything lets the user know their filters are too narrow.
  var filtered=meta.filter(function(o){
    if(allowedOrgIds){
      if(!allowedOrgIds.has(o.id))return false;
    } else if(!_orgInDisc(o.discipline||'')){
      return false;
    }
    if(catF!=='all'){
      var oc=(o.category||'').toLowerCase();
      // Venues are dual-category; always kept when catF is a specific category.
      if(o.discipline==='venue')return true;
      if(catF==='publicroad')return oc==='publicroad';
      // Orgs tagged 'both' (race + trackday) show for either race or trackday.
      if(oc==='both')return catF==='race'||catF==='trackday';
      if(oc!==catF)return false;
    }
    if(orgSearchQ && (o.name||'').toLowerCase().indexOf(orgSearchQ) < 0) return false;
    // DEFAULT: hide orgs with zero events. They were rendered as grey-dot
    // rows with "0" badges and just padded the list. Set window.GARA_SHOW_EMPTY
    // = true (e.g. via a toggle) to include them.
    if(!window.GARA_SHOW_EMPTY && !o.has_events) return false;
    return true;
  });

  // Running total for the All row: events from filtered orgs only
  var filteredIds=new Set(filtered.map(function(o){return o.id;}));
  var totalEvents=0;
  (window.GARA_EVENTS&&window.GARA_EVENTS.events||[]).forEach(function(e){
    if(filteredIds.has(e.org_id))totalEvents++;
  });

  var rows='<div class="org-row'+(orgF==='All'?' ac':'')+'" data-oid="All">'+
    '<span class="org-dot live"></span>'+
    '<span class="org-name">All orgs</span>'+
    '<span class="org-count">'+totalEvents+'</span>'+
  '</div>';
  if(filtered.length===0){
    rows+='<div class="org-empty" style="padding:14px;color:var(--s-dim);font-size:11px;text-align:center;letter-spacing:1.5px;text-transform:uppercase;font-family:Oswald,sans-serif">No orgs match</div>';
  }
  rows+=filtered.map(function(o){
    var live=o.has_events?' live':'';
    var disc=(o.discipline||'moto').toLowerCase();
    var count=o.event_count||0;
    return '<div class="org-row'+(orgF===o.id?' ac':'')+'" data-oid="'+o.id+'" title="'+
      (o.full_name||o.name)+(o.has_events?' — synced':' — no events found')+'">'+
      '<span class="org-dot'+live+'"></span>'+
      '<span class="org-name">'+o.name+'</span>'+
      '<span class="org-badge '+disc+'">'+disc+'</span>'+
      '<span class="org-count">'+count+'</span>'+
    '</div>';
  }).join('');
  wrap.innerHTML=rows;
  wrap.querySelectorAll('.org-row').forEach(function(el){
    el.addEventListener('click',function(){
      orgF=this.dataset.oid;
      buildOrgs();refresh();updTypes();
    });
  });
}

// State sidebar
function buildStates(){
  var states=['All'].concat([].concat(Array.from(new Set(FACILITIES.map(function(f){return f.s;})))).sort());
  var wrap=document.getElementById('st-list');
  var filter=document.getElementById('st-search').value.toLowerCase();
  var filtered=states.filter(function(s){return s.toLowerCase().includes(filter);});
  wrap.innerHTML=filtered.map(function(s){
    return '<div class="sfi'+(stateF===s?' ac':'')+'" data-st="'+s+'">'+s+'</div>';
  }).join('');
  wrap.querySelectorAll('.sfi').forEach(function(el){
    el.addEventListener('click',function(){stateF=this.dataset.st;buildStates();buildOrgs();refresh();updTypes();});
  });
}

function refresh(){
  addMkrs();
  buildCar();
  // If a facility is currently selected, re-render its event panel so the
  // discipline filter (or any other filter) takes effect immediately —
  // otherwise the panel keeps the old discipline's events until the user
  // re-clicks the marker.
  if(typeof sel!=='undefined' && sel) renderEvents(sel);
  // Persist current filter state into the URL so the share button + a manual
  // copy-paste of the address bar both produce a reproducible view.
  syncFiltersToUrl();
}
function resetF(){
  catF='all';stateF='All';orgF='All';discF='all';priceF='all';
  // Also clear the search inputs + close drawers + drop selection so 'reset'
  // really means 'back to a clean default view'.
  var ss=document.getElementById('st-search'); if(ss)ss.value='';
  var os=document.getElementById('org-search'); if(os)os.value='';
  var qs=document.getElementById('search'); if(qs)qs.value='';
  var sug=document.getElementById('suggest'); if(sug)sug.style.display='none';
  var scr=document.getElementById('filter-scrim'); if(scr)scr.classList.remove('show');
  var sb=document.getElementById('sb'); if(sb)sb.classList.remove('open');
  document.body.classList.remove('filter-open');
  document.body.classList.remove('legend-open');
  updTypes();buildStates();buildOrgs();initCats();initDiscs();initPrices();refresh();
}

function initDiscs(){
  var wraps=document.querySelectorAll('.disc-btns');
  wraps.forEach(function(wrap){
    wrap.innerHTML='';
    DISCS.forEach(function(d){
      var b=document.createElement('button');b.className='tbtn'+(discF===d.id?' ac':'');
      b.textContent=d.label;b.dataset.disc=d.id;
      b.addEventListener('click',function(){discF=d.id;updTypes();buildOrgs();refresh();});
      wrap.appendChild(b);
    });
  });
}

function initPrices(){
  var wraps=document.querySelectorAll('.price-btns');
  wraps.forEach(function(wrap){
    wrap.innerHTML='';
    PRICES.forEach(function(p){
      var b=document.createElement('button');b.className='tbtn'+(priceF===p.id?' ac':'');
      b.textContent=p.label;b.dataset.price=p.id;
      b.addEventListener('click',function(){priceF=p.id;updTypes();buildOrgs();refresh();});
      wrap.appendChild(b);
    });
  });
}

// Carousel — shows only facilities inside the current map viewport so the
// card list narrows naturally as you pan/zoom in. At country view all
// facilities pass the filter; at a close-up view only what's on screen remains.
// Shared debounce for the hover-fan hide. buildCar() runs every map moveend
// so we guard the fan mouseenter/leave with a "wired once" flag.
var _fanHideTimer=null;
function _fanHideSoon(){
  clearTimeout(_fanHideTimer);
  var fanEl=document.getElementById('cfan');
  _fanHideTimer=setTimeout(function(){if(fanEl)fanEl.classList.remove('show');},180);
}
(function wireFanHover(){
  var fanEl=document.getElementById('cfan');
  if(!fanEl||fanEl._gHoverBound)return;
  fanEl._gHoverBound=true;
  fanEl.addEventListener('mouseenter',function(){clearTimeout(_fanHideTimer);});
  fanEl.addEventListener('mouseleave',_fanHideSoon);
  // Belt and suspenders: any tap that lands OUTSIDE the fan or a multi-config
  // card hides it. Fixes a class of "stuck-visible fan" bugs on touch laptops
  // and iPad where mouseleave is unreliable.
  document.addEventListener('pointerdown', function(e){
    if(!fanEl.classList.contains('show')) return;
    if(fanEl.contains(e.target)) return;
    if(e.target.closest && e.target.closest('.tc')) return;
    fanEl.classList.remove('show');
  }, true);
})();

// ── Card pre-build (one-shot, no layout mutation) ────────────────────
// Builds one .tc node per facility into _cardPool. Listeners are bound
// here ONCE (mouseenter for hover-fan on desktop multi-config, onclick
// for selTk) so buildCar() never re-binds. content-visibility:auto +
// contain-intrinsic-size let the browser skip rendering off-screen
// cards entirely on Android Chrome -- biggest single win for a long
// horizontal strip. Critically: this function only writes to the
// pool's owned DOM nodes; it never mutates #app, #cars, #map-wrap,
// or any positioned ancestor of #map. That's the constraint that
// kept the previous pre-build attempt out of trouble.
function _buildOneCardEl(t){
  var c = document.createElement('div');
  c.className = 'tc';
  c.dataset.n = t.n;
  c.style.contentVisibility = 'auto';
  c.style.containIntrinsicSize = '320px 230px';
  c.onclick = function(){ selTk(t); };
  var hintHTML = (t.configs && t.configs.length > 1) ? '<div class="cfg-hint">'+t.configs.length+' CFG</div>' : '';
  c.innerHTML = hintHTML +
    '<div class="th"><div class="ts">'+t.s+'</div><div class="tn">'+t.n+'</div><div class="tcty">'+(t.c||'')+
    '</div></div><div class="tsm"><div class="rs" data-sim="'+t.n.replace(/"/g,'&quot;')+'" style="height:100px"></div></div>'+
    '<div class="tst">'+[['Len',t.l,0],['Turns',t.tu,0],['Elev.',t.el,0],['Key',t.sg,1]].map(function(x){
      return '<div><div class="tsl">'+x[0]+'</div><div class="tsv'+(x[2]?' gd':'')+'">'+x[1]+'</div></div>';
    }).join('')+'</div><div class="ttp">'+t.tp+'</div>';
  var _isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints||0) > 0;
  var fanEl = document.getElementById('cfan');
  if(!_isTouch && fanEl && t.configs && t.configs.length > 1){
    c.addEventListener('mouseenter', function(){
      clearTimeout(_fanHideTimer);
      fanEl.innerHTML = t.configs.map(function(cfg, i){
        var cur = i === t._activeConfig ? ' cur' : '';
        return '<div class="fan-chip'+cur+'" data-ci="'+i+'">'+cfg._label+'</div>';
      }).join('');
      fanEl.querySelectorAll('.fan-chip').forEach(function(chip){
        chip.addEventListener('click', function(e){
          e.stopPropagation();
          clearTimeout(_fanHideTimer);
          fanEl.classList.remove('show');
          var ci = parseInt(this.dataset.ci);
          if(ci === t._activeConfig){ selTk(t); return; }
          var cfg = t.configs[ci];
          t._activeConfig = ci;
          t.l = cfg.l; t.tu = cfg.tu; t.el = cfg.el; t.sg = cfg.sg; t.tp = cfg.tp; t.o = cfg.o;
          // Refresh THIS card's stats in place + re-sim
          _refreshOneCard(t);
          selTk(t);
        });
      });
      var rect = c.getBoundingClientRect();
      fanEl.style.left = (rect.left + 6) + 'px';
      fanEl.style.width = (rect.width - 12) + 'px';
      fanEl.style.bottom = (window.innerHeight - rect.top) + 'px';
      fanEl.style.top = 'auto';
      fanEl.classList.add('show');
    });
    c.addEventListener('mouseleave', _fanHideSoon);
  }
  return c;
}
function _refreshOneCard(t){
  // Re-paint a single card's stats + sim slot in place. Used when a
  // multi-config track switches active config; no DOM tear-down.
  var c = _cardPool[t.n];
  if(!c) return;
  var hintHTML = (t.configs && t.configs.length > 1) ? '<div class="cfg-hint">'+t.configs.length+' CFG</div>' : '';
  c.innerHTML = hintHTML +
    '<div class="th"><div class="ts">'+t.s+'</div><div class="tn">'+t.n+'</div><div class="tcty">'+(t.c||'')+
    '</div></div><div class="tsm"><div class="rs" data-sim="'+t.n.replace(/"/g,'&quot;')+'" style="height:100px"></div></div>'+
    '<div class="tst">'+[['Len',t.l,0],['Turns',t.tu,0],['Elev.',t.el,0],['Key',t.sg,1]].map(function(x){
      return '<div><div class="tsl">'+x[0]+'</div><div class="tsv'+(x[2]?' gd':'')+'">'+x[1]+'</div></div>';
    }).join('')+'</div><div class="ttp">'+t.tp+'</div>';
  // The .rs element is fresh -- if the card is currently observed by
  // _carObserver, the next IO entry fires rsim on it.
}
function _preBuildAllCards(){
  if(_cardsPooled) return;
  for(var i = 0; i < FACILITIES.length; i++){
    var t = FACILITIES[i];
    if(!_cardPool[t.n]) _cardPool[t.n] = _buildOneCardEl(t);
  }
  _cardsPooled = true;
  // Single persistent IntersectionObserver: created here, observes
  // cards lazily as they appear in #cars via the buildCar fast path.
  // The IO's root is #cars itself, so it tracks horizontal-scroll
  // visibility. Cards scrolling out of view get their sim cleaned up.
  var sc = document.getElementById('cars');
  if(sc && 'IntersectionObserver' in window && !_carObserver){
    _carObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        var rs = en.target.querySelector('[data-sim]');
        if(!rs) return;
        var name = rs.dataset.sim;
        var t = FACILITIES.find(function(x){ return x.n === name; });
        if(!t || !t.o) return;
        if(en.isIntersecting){
          if(!rs.querySelector('svg')){
            var stop = rsim(rs, t.o, 3, 100);
            if(_cardSimCleanup) _cardSimCleanup.set(en.target, stop);
            cardSims.push(stop);
          }
        } else {
          // Stop the sim for an off-screen card; svg DOM stays so it
          // re-shows instantly when scrolled back into view.
          var prev = _cardSimCleanup && _cardSimCleanup.get(en.target);
          if(prev){ try{ prev(); }catch(e){} _cardSimCleanup.delete(en.target); }
        }
      });
    }, { root: sc, rootMargin: '200px' });
  }
}

function buildCar(){
  // CAROUSEL REMOVED 2026-05-22. The bottom-strip key replaces the
  // carousel on every breakpoint. This function survives only to
  // refresh the header count (`#hcount`) on filter changes (called
  // from refresh()). NOT called on map moveend anymore — pan/zoom was
  // killing desktop perf and the count is filter-aware not view-aware.
  cardSims.forEach(function(fn){ try{ fn(); }catch(e){} });
  cardSims = [];
  if(typeof WeakMap !== 'undefined'){ _cardSimCleanup = new WeakMap(); }

  // Mobile: #hcount is display:none (see .hcount{display:none} inside
  // @media max-width:768px), so the gf() pass below would be wasted work.
  if(typeof isMobileBreakpoint === 'function' && isMobileBreakpoint()) return;

  var hcEl = document.getElementById('hcount');
  if(!hcEl) return;

  var ft = gf();
  var total = FACILITIES.length;
  // No filters → just the total. With filters → "X of N tracks · MOTO · CA"
  var hasFilter = (discF !== 'all') || (stateF !== 'All') || (catF !== 'all') ||
                  (priceF !== 'all') || (orgF !== 'All');
  var parts;
  if(hasFilter){
    parts = [ft.length + ' of ' + total + ' tracks'];
    if(discF !== 'all')  parts.push(discF.toUpperCase());
    if(stateF !== 'All') parts.push(stateF);
    if(catF !== 'all')   parts.push(catF.toUpperCase());
    if(priceF !== 'all') parts.push('$' + priceF.toUpperCase());
    if(orgF !== 'All')   parts.push(orgF);
  }else{
    parts = [total + ' tracks'];
  }
  hcEl.textContent = parts.join(' · ');
}

function scrl(d){
  // Measure the first card so prev/next jump by an actual card width (+gap)
  // rather than the hard-coded 260px that didn't match desktop 300px or
  // mobile 240/210px sizes.
  var car=document.getElementById('cars');
  var first=car.querySelector('.tc');
  var w = first ? (first.offsetWidth + 8) : 260;
  car.scrollBy({left:d*w,behavior:'smooth'});
}

// Carousel wheel: only convert vertical wheel to horizontal when the gesture
// is mostly horizontal (trackpad scroll) OR the carousel is the actual focus
// of intent (cursor inside). Default vertical scrolls fall through to the
// page so users aren't trapped scrolling over the carousel.
document.getElementById('cars').addEventListener('wheel',function(e){
  var horizontal=Math.abs(e.deltaX) > Math.abs(e.deltaY);
  if(horizontal){
    e.preventDefault();
    this.scrollLeft += e.deltaX;
  }
  // vertical wheel: let the page scroll naturally
},{passive:false});

// Carousel-locked map flyover: when the user stops scrolling the strip,
// figure out which card is centered in the viewport and fly the map to
// that track. Turns the carousel into a "film strip" — drag cards, the
// world pans under you. Skipped while the user is actively driving the
// map via selTk() (we tag the carousel during a fly-from-card with a
// short-lived data-attr so we don't loop).
(function(){
  var car=document.getElementById('cars');
  if(!car) return;
  var lockUntil=0;
  // Mark a flyover as user-driven so selTk's own scrollIntoView doesn't
  // re-trigger the scrollend handler in a feedback loop.
  function pickCenteredCard(){
    if(Date.now() < lockUntil) return;
    if(!map || !map.flyTo) return;
    try{
      if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    }catch(e){}
    var rect=car.getBoundingClientRect();
    var midX = rect.left + rect.width/2;
    var cards = car.querySelectorAll('.tc');
    var best=null, bestDist=Infinity;
    cards.forEach(function(c){
      var r=c.getBoundingClientRect();
      var cx = r.left + r.width/2;
      var d=Math.abs(cx - midX);
      if(d < bestDist){ bestDist=d; best=c; }
    });
    if(!best) return;
    var name = best.dataset.n;
    if(!name || (sel && sel.n===name)) return;
    var t = FACILITIES.find(function(f){return f.n===name;});
    if(!t) return;
    lockUntil = Date.now() + 1500;
    // Use a softer fly than selTk — pan only, no pitch change, shorter.
    map.flyTo({center:[t.lo,t.la], zoom:Math.max(map.getZoom(),10), duration:900, essential:false});
  }
  // scrollend lands once the swipe momentum stops; throttle for older Safari
  // that doesn't support it natively.
  var endTimer=null;
  car.addEventListener('scroll',function(){
    clearTimeout(endTimer);
    endTimer=setTimeout(pickCenteredCard, 200);
  },{passive:true});
})();

// IntersectionObserver handles lazy sim loading now

function showMapFallback(reason){
  // Render a clean fallback over the map container so the user sees a real
  // message instead of a hung browser timeout.
  var mw=document.getElementById('map-wrap');
  if(!mw) return;
  var fb=document.createElement('div');
  fb.id='gara-map-fallback';
  fb.style.cssText='position:absolute;inset:0;z-index:50;display:flex;align-items:center;justify-content:center;background:#0a0a0d;color:#c8c8cc;padding:24px;text-align:center;font-family:Oswald,sans-serif;';
  fb.innerHTML=
    '<div style="max-width:420px">'
      +'<div style="font-size:11px;letter-spacing:3px;color:#c9a84c;text-transform:uppercase;margin-bottom:10px">Map unavailable</div>'
      +'<div style="font-family:\'IBM Plex Sans\',sans-serif;font-size:14px;line-height:1.55;color:#c8c8cc;margin-bottom:14px">'
        +'The map service can\'t be reached from your network right now. '
        +(reason==='blocked'?'This usually means a corporate firewall, ad-blocker, or VPN is blocking <code style="color:#e8c870">api.mapbox.com</code>. ':'')
        +'Try refreshing, switching networks, or using a different browser.'
      +'</div>'
      +'<button onclick="location.reload()" style="background:#c9a84c;color:#000;border:0;padding:10px 22px;font:600 11px/1 Oswald,sans-serif;letter-spacing:2px;text-transform:uppercase;cursor:pointer">Refresh</button>'
      +'<div style="font-size:11px;color:#5a5a62;margin-top:18px;letter-spacing:1px">The rest of the site works — try <a href="/" style="color:#c9a84c;text-decoration:underline">homepage</a> or <a href="/collections/moto-tires" style="color:#c9a84c;text-decoration:underline">tires</a>.</div>'
    +'</div>';
  mw.appendChild(fb);
}

function init(){
  window._garaInit=true;
  document.getElementById('search').placeholder='Search for tracks and events';
  // Mapbox availability gate. If the CDN script onerror'd, mapboxgl is undefined.
  if(window.GARA_MAPBOX_BLOCKED || typeof mapboxgl==='undefined'){
    showMapFallback('blocked');
    // Skip map-dependent init but allow the rest of the page (search, lists)
    // to keep working so the user isn't stranded.
    try{initSearch();initCats();initDiscs();initPrices();buildStates();
      document.getElementById('st-search').addEventListener('input',buildStates);
      buildOrgIndex();buildOrgs();buildCar();
      initMobileFilters();initMobileBottomSheet();initMobileFilterChips();updTypes();
    }catch(e){console.warn('partial init:',e);}
    return;
  }
  initMap();initSearch();initCats();initDiscs();initPrices();buildStates();
  document.getElementById('st-search').addEventListener('input',buildStates);
  var _orgSearchEl=document.getElementById('org-search');
  if(_orgSearchEl) _orgSearchEl.addEventListener('input',function(){ buildOrgs(); });
  buildOrgIndex();
  buildOrgs();
  buildCar();
  // PERF pre-build removed 2026-05-22 with the carousel — no cards to render.
  initMobileFilters();
  initMobileBottomSheet();
  initMobileFilterChips();
  updTypes();  // populate the mobile chip row with initial values

  // ?track= deep-link consumer. Match the param against facility names
  // (case-insensitive, ignoring punctuation) and select the first hit. Falls
  // through silently if no match — the user sees the default map.
  if(_pendingTrackParam){
    try{
      var needle=_pendingTrackParam.toLowerCase().replace(/[^a-z0-9]+/g,'');
      var hit=FACILITIES.find(function(f){
        return (f.n||'').toLowerCase().replace(/[^a-z0-9]+/g,'') === needle;
      });
      if(hit){
        // Defer one frame so the map is ready to flyTo.
        setTimeout(function(){ try{ selTk(hit); }catch(e){} }, 350);
      }
      _pendingTrackParam=null;
    }catch(e){}
  }
  // Initial URL sync (after persisted localStorage values may have overridden
  // the defaults) so a reload preserves the same view.
  syncFiltersToUrl();
  // Watchdog: if Mapbox canvas isn't drawing after 12s, tiles never arrived.
  // The Mapbox-injected <canvas> reports its drawable width — if it's 0, the
  // map never finished loading (tile fetch blocked, style fetch failed, etc.).
  setTimeout(function(){
    var canvas=document.querySelector('#map .mapboxgl-canvas');
    var ok = canvas && canvas.width > 0 && canvas.height > 0;
    if(!ok && !document.getElementById('gara-map-fallback')) showMapFallback('slow');
  },12000);
}
// Fallback init if external data doesn't load
setTimeout(function(){if(!window._garaInit)init();},2500);
